import { mnml } from "https://unpkg.com/@dryan-llc/mnml.js@2.0";

const terms = [
  {
    Group: "Parents and Older Siblings",
    Relationship: "Father",
    "\u2018my\u2019": {
      Vocative: "tu\u0301ta",
      Absolute: "natu\u0301tas",
      Associative: "natu\u0301tasayin",
      Ergative: "natu\u0301tasan\u0268m",
      Genitive: "natutasanmi\u0301",
      Accusative: "natu\u0301tasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "tu\u0301t",
      Associative: "tu\u0301tin",
      Ergative: "tuta\u0301p",
      Genitive: "tutaami\u0301",
      Accusative: "tuta\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ps\u030c\u0268\u0301t",
      Associative: "ps\u030c\u0268\u0301tin",
      Ergative: "ps\u030c\u0268\u0301tn\u0268m",
      Genitive: "ps\u030c\u0268tpmi\u0301",
      Accusative: "ps\u030c\u0268\u0301tna",
      "Accusative coreferential": "ps\u030c\u0268\u0301tpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nps\u030c\u0268t",
      Associative: "p\u0268\u0301nps\u030c\u0268tin",
      Ergative: "p\u0268\u0301nps\u030c\u0268tn\u0268m",
      Genitive: "p\u0268nps\u030c\u0268tpmi\u0301",
      Accusative: "p\u0268\u0301nps\u030ctna",
      "Accusative coreferential": "p\u0268\u0301nps\u030ctpa",
    },
    Vocative: {
      "\u2018my\u2019": "tu\u0301ta",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "natu\u0301tas",
      "\u2018your\u2019": "tu\u0301t",
      Proximate: "ps\u030c\u0268\u0301t",
      Obviative: "p\u0268\u0301nps\u030c\u0268t",
    },
    Associative: {
      "\u2018my\u2019": "natu\u0301tasayin",
      "\u2018your\u2019": "tu\u0301tin",
      Proximate: "ps\u030c\u0268\u0301tin",
      Obviative: "p\u0268\u0301nps\u030c\u0268tin",
    },
    Ergative: {
      "\u2018my\u2019": "natu\u0301tasan\u0268m",
      "\u2018your\u2019": "tuta\u0301p",
      Proximate: "ps\u030c\u0268\u0301tn\u0268m",
      Obviative: "p\u0268\u0301nps\u030c\u0268tn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "natutasanmi\u0301",
      "\u2018your\u2019": "tutaami\u0301",
      Proximate: "ps\u030c\u0268tpmi\u0301",
      Obviative: "p\u0268nps\u030c\u0268tpmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "natu\u0301tasaan",
      "\u2018your\u2019": "tuta\u0301p",
      Proximate: "ps\u030c\u0268\u0301tna",
      Obviative: "p\u0268\u0301nps\u030ctna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ps\u030c\u0268\u0301tpa",
      Obviative: "p\u0268\u0301nps\u030ctpa",
    },
  },
  {
    Group: "Parents and Older Siblings",
    Relationship: "Mother",
    "\u2018my\u2019": {
      Vocative: "i\u0301\u0142a",
      Absolute: "na\u02c0i\u0301\u0142as",
      Associative: "na\u02c0i\u0301\u0142asayin",
      Ergative: "na\u02c0i\u0301\u0142asan\u0268m",
      Genitive: "na\u02c0i\u0142asanmi\u0301",
      Accusative: "na\u02c0i\u0301\u0142asaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301\u0142",
      Associative: "i\u0301\u0142in",
      Ergative: "i\u0142a\u0301p",
      Genitive: "i\u0142aami\u0301",
      Accusative: "i\u0142a\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pc\u030ca\u0301",
      Associative: "pc\u030ca\u0301yin",
      Ergative: "pc\u030ca\u0301pn\u0268m",
      Genitive: "pc\u030capmi\u0301",
      Accusative: "pc\u030ca\u0301an",
      "Accusative coreferential": "pc\u030ca\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npc\u030ca",
      Associative: "p\u0268\u0301npc\u030cayin",
      Ergative: "p\u0268\u0301npc\u030capn\u0268m",
      Genitive: "p\u0268npc\u030capmi\u0301",
      Accusative: "p\u0268\u0301npc\u030caan",
      "Accusative coreferential": "p\u0268\u0301npc\u030capa",
    },
    Vocative: {
      "\u2018my\u2019": "i\u0301\u0142a",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "na\u02c0i\u0301\u0142as",
      "\u2018your\u2019": "i\u0301\u0142",
      Proximate: "pc\u030ca\u0301",
      Obviative: "p\u0268\u0301npc\u030ca",
    },
    Associative: {
      "\u2018my\u2019": "na\u02c0i\u0301\u0142asayin",
      "\u2018your\u2019": "i\u0301\u0142in",
      Proximate: "pc\u030ca\u0301yin",
      Obviative: "p\u0268\u0301npc\u030cayin",
    },
    Ergative: {
      "\u2018my\u2019": "na\u02c0i\u0301\u0142asan\u0268m",
      "\u2018your\u2019": "i\u0142a\u0301p",
      Proximate: "pc\u030ca\u0301pn\u0268m",
      Obviative: "p\u0268\u0301npc\u030capn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "na\u02c0i\u0142asanmi\u0301",
      "\u2018your\u2019": "i\u0142aami\u0301",
      Proximate: "pc\u030capmi\u0301",
      Obviative: "p\u0268npc\u030capmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "na\u02c0i\u0301\u0142asaan",
      "\u2018your\u2019": "i\u0142a\u0301p",
      Proximate: "pc\u030ca\u0301an",
      Obviative: "p\u0268\u0301npc\u030caan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pc\u030ca\u0301pa",
      Obviative: "p\u0268\u0301npc\u030capa",
    },
  },
  {
    Group: "Parents and Older Siblings",
    Relationship: "Older Brother",
    "\u2018my\u2019": {
      Vocative: "ya\u0301ya",
      Absolute: "naya\u0301yas",
      Associative: "naya\u0301yasayin",
      Ergative: "naya\u0301yasan\u0268m",
      Genitive: "nayayasanmi\u0301",
      Accusative: "naya\u0301yasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "ya\u0301s\u030c",
      Associative: "ya\u0301s\u030cin",
      Ergative: "yas\u030ca\u0301p",
      Genitive: "yas\u030caami\u0301",
      Accusative: "yas\u030ca\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pya\u0301p",
      Associative: "pya\u0301pin",
      Ergative: "pya\u0301pn\u0268m",
      Genitive: "pyapmi\u0301",
      Accusative: "pya\u0301pna",
      "Accusative coreferential": "pya\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npyap",
      Associative: "p\u0268\u0301npyapin",
      Ergative: "p\u0268\u0301npyapn\u0268m",
      Genitive: "p\u0268npyapmi\u0301",
      Accusative: "p\u0268\u0301npyapna",
      "Accusative coreferential": "p\u0268\u0301npyapa",
    },
    Vocative: {
      "\u2018my\u2019": "ya\u0301ya",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "naya\u0301yas",
      "\u2018your\u2019": "ya\u0301s\u030c",
      Proximate: "pya\u0301p",
      Obviative: "p\u0268\u0301npyap",
    },
    Associative: {
      "\u2018my\u2019": "naya\u0301yasayin",
      "\u2018your\u2019": "ya\u0301s\u030cin",
      Proximate: "pya\u0301pin",
      Obviative: "p\u0268\u0301npyapin",
    },
    Ergative: {
      "\u2018my\u2019": "naya\u0301yasan\u0268m",
      "\u2018your\u2019": "yas\u030ca\u0301p",
      Proximate: "pya\u0301pn\u0268m",
      Obviative: "p\u0268\u0301npyapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "nayayasanmi\u0301",
      "\u2018your\u2019": "yas\u030caami\u0301",
      Proximate: "pyapmi\u0301",
      Obviative: "p\u0268npyapmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "naya\u0301yasaan",
      "\u2018your\u2019": "yas\u030ca\u0301p",
      Proximate: "pya\u0301pna",
      Obviative: "p\u0268\u0301npyapna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pya\u0301pa",
      Obviative: "p\u0268\u0301npyapa",
    },
  },
  {
    Group: "Parents and Older Siblings",
    Relationship: "Older Sister",
    "\u2018my\u2019": {
      Vocative: "n\u0268\u0301s\u030ca",
      Absolute: "nana\u0301nas",
      Associative: "nana\u0301nasayin",
      Ergative: "nana\u0301nasan\u0268m",
      Genitive: "nananasanmi\u0301",
      Accusative: "nana\u0301nasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "n\u0268\u0301s\u030c",
      Associative: "n\u0268\u0301s\u030cin",
      Ergative: "n\u0268s\u030ca\u0301p",
      Genitive: "n\u0268s\u030caami\u0301",
      Accusative: "n\u0268s\u030ca\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pa\u0301t",
      Associative: "pa\u0301tin",
      Ergative: "pa\u0301tn\u0268m",
      Genitive: "patpmi\u0301",
      Accusative: "pa\u0301tna",
      "Accusative coreferential": "pa\u0301tpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npat",
      Associative: "p\u0268\u0301npatin",
      Ergative: "p\u0268\u0301npatn\u0268m",
      Genitive: "p\u0268npatpmi\u0301",
      Accusative: "p\u0268\u0301npatna",
      "Accusative coreferential": "p\u0268\u0301npatpa",
    },
    Vocative: {
      "\u2018my\u2019": "n\u0268\u0301s\u030ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "nana\u0301nas",
      "\u2018your\u2019": "n\u0268\u0301s\u030c",
      Proximate: "pa\u0301t",
      Obviative: "p\u0268\u0301npat",
    },
    Associative: {
      "\u2018my\u2019": "nana\u0301nasayin",
      "\u2018your\u2019": "n\u0268\u0301s\u030cin",
      Proximate: "pa\u0301tin",
      Obviative: "p\u0268\u0301npatin",
    },
    Ergative: {
      "\u2018my\u2019": "nana\u0301nasan\u0268m",
      "\u2018your\u2019": "n\u0268s\u030ca\u0301p",
      Proximate: "pa\u0301tn\u0268m",
      Obviative: "p\u0268\u0301npatn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "nananasanmi\u0301",
      "\u2018your\u2019": "n\u0268s\u030caami\u0301",
      Proximate: "patpmi\u0301",
      Obviative: "p\u0268npatpmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "nana\u0301nasaan",
      "\u2018your\u2019": "n\u0268s\u030ca\u0301p",
      Proximate: "pa\u0301tna",
      Obviative: "p\u0268\u0301npatna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pa\u0301tpa",
      Obviative: "p\u0268\u0301npatpa",
    },
  },
  {
    Group: "Grandparents",
    Relationship: "Paternal Grandfather",
    "\u2018my\u2019": {
      Vocative: "pu\u0301s\u030ca",
      Absolute: "napu\u0301sas",
      Associative: "napu\u0301sasayin",
      Ergative: "napu\u0301sasan\u0268m",
      Genitive: "napusasanmi\u0301",
      Accusative: "napu\u0301sasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "\u0268pu\u0301s\u030c",
      Associative: "\u0268pu\u0301s\u030cin",
      Ergative: "pus\u030ca\u0301p",
      Genitive: "pus\u030cami\u0301",
      Accusative: "pus\u030ca\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pu\u0301s\u030ca",
      Associative: "pu\u0301s\u030cayin",
      Ergative: "pu\u0301s\u030capn\u0268m",
      Genitive: "pus\u030cami\u0301",
      Accusative: "pu\u0301s\u030caan",
      "Accusative coreferential": "pu\u0301s\u030capa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npus\u030ca",
      Associative: "p\u0268\u0301npus\u030cayin",
      Ergative: "p\u0268\u0301npus\u030capn\u0268m",
      Genitive: "p\u0268npus\u030cami\u0301",
      Accusative: "p\u0268\u0301npu\u0301s\u030caan",
      "Accusative coreferential": "pu\u0301s\u030capa",
    },
    Vocative: {
      "\u2018my\u2019": "pu\u0301s\u030ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "napu\u0301sas",
      "\u2018your\u2019": "\u0268pu\u0301s\u030c",
      Proximate: "pu\u0301s\u030ca",
      Obviative: "p\u0268\u0301npus\u030ca",
    },
    Associative: {
      "\u2018my\u2019": "napu\u0301sasayin",
      "\u2018your\u2019": "\u0268pu\u0301s\u030cin",
      Proximate: "pu\u0301s\u030cayin",
      Obviative: "p\u0268\u0301npus\u030cayin",
    },
    Ergative: {
      "\u2018my\u2019": "napu\u0301sasan\u0268m",
      "\u2018your\u2019": "pus\u030ca\u0301p",
      Proximate: "pu\u0301s\u030capn\u0268m",
      Obviative: "p\u0268\u0301npus\u030capn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "napusasanmi\u0301",
      "\u2018your\u2019": "pus\u030cami\u0301",
      Proximate: "pus\u030cami\u0301",
      Obviative: "p\u0268npus\u030cami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "napu\u0301sasaan",
      "\u2018your\u2019": "pus\u030ca\u0301p",
      Proximate: "pu\u0301s\u030caan",
      Obviative: "p\u0268\u0301npu\u0301s\u030caan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pu\u0301s\u030capa",
      Obviative: "pu\u0301s\u030capa",
    },
  },
  {
    Group: "Grandparents",
    Relationship: "Paternal Grandmother",
    "\u2018my\u2019": {
      Vocative: "a\u0301la",
      Absolute: "na\u02c0a\u0301las",
      Associative: "na\u02c0a\u0301lasayin",
      Ergative: "na\u02c0a\u0301lasan\u0268m",
      Genitive: "na\u02c0alasanmi\u0301",
      Accusative: "na\u02c0a\u0301lasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "a\u0301l",
      Associative: "a\u0301lin",
      Ergative: "ala\u0301p",
      Genitive: "alami\u0301",
      Accusative: "ala\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301la",
      Associative: "a\u0301layin",
      Ergative: "a\u0301lapn\u0268m",
      Genitive: "alami\u0301",
      Accusative: "a\u0301laan",
      "Accusative coreferential": "a\u0301lapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0ala",
      Associative: "p\u0268\u0301n\u02c0alayin",
      Ergative: "p\u0268\u0301n\u02c0alapn\u0268m",
      Genitive: "p\u0268n\u02c0alami\u0301",
      Accusative: "p\u0268\u0301n\u02c0alaan",
      "Accusative coreferential": "p\u0268\u0301n\u02c0alapa",
    },
    Vocative: {
      "\u2018my\u2019": "a\u0301la",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "na\u02c0a\u0301las",
      "\u2018your\u2019": "a\u0301l",
      Proximate: "a\u0301la",
      Obviative: "p\u0268\u0301n\u02c0ala",
    },
    Associative: {
      "\u2018my\u2019": "na\u02c0a\u0301lasayin",
      "\u2018your\u2019": "a\u0301lin",
      Proximate: "a\u0301layin",
      Obviative: "p\u0268\u0301n\u02c0alayin",
    },
    Ergative: {
      "\u2018my\u2019": "na\u02c0a\u0301lasan\u0268m",
      "\u2018your\u2019": "ala\u0301p",
      Proximate: "a\u0301lapn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0alapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "na\u02c0alasanmi\u0301",
      "\u2018your\u2019": "alami\u0301",
      Proximate: "alami\u0301",
      Obviative: "p\u0268n\u02c0alami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "na\u02c0a\u0301lasaan",
      "\u2018your\u2019": "ala\u0301p",
      Proximate: "a\u0301laan",
      Obviative: "p\u0268\u0301n\u02c0alaan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301lapa",
      Obviative: "p\u0268\u0301n\u02c0alapa",
    },
  },
  {
    Group: "Grandparents",
    Relationship: "Maternal Grandfather",
    "\u2018my\u2019": {
      Vocative: "ti\u0301la",
      Absolute: "nati\u0301las",
      Associative: "nati\u0301lasayin",
      Ergative: "nati\u0301lasan\u0268m",
      Genitive: "natilasanmi\u0301",
      Accusative: "nati\u0301lasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "ti\u0301l",
      Associative: "ti\u0301lin",
      Ergative: "tila\u0301p",
      Genitive: "tilami\u0301",
      Accusative: "tila\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ti\u0301la",
      Associative: "ti\u0301layin",
      Ergative: "ti\u0301lapn\u0268m",
      Genitive: "tilami\u0301",
      Accusative: "ti\u0301laan",
      "Accusative coreferential": "ti\u0301lapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301ntila",
      Associative: "p\u0268\u0301ntilayin",
      Ergative: "p\u0268\u0301ntilapn\u0268m",
      Genitive: "p\u0268ntilami\u0301",
      Accusative: "p\u0268\u0301ntilaan",
      "Accusative coreferential": "p\u0268\u0301ntilapa",
    },
    Vocative: {
      "\u2018my\u2019": "ti\u0301la",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "nati\u0301las",
      "\u2018your\u2019": "ti\u0301l",
      Proximate: "ti\u0301la",
      Obviative: "p\u0268\u0301ntila",
    },
    Associative: {
      "\u2018my\u2019": "nati\u0301lasayin",
      "\u2018your\u2019": "ti\u0301lin",
      Proximate: "ti\u0301layin",
      Obviative: "p\u0268\u0301ntilayin",
    },
    Ergative: {
      "\u2018my\u2019": "nati\u0301lasan\u0268m",
      "\u2018your\u2019": "tila\u0301p",
      Proximate: "ti\u0301lapn\u0268m",
      Obviative: "p\u0268\u0301ntilapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "natilasanmi\u0301",
      "\u2018your\u2019": "tilami\u0301",
      Proximate: "tilami\u0301",
      Obviative: "p\u0268ntilami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "nati\u0301lasaan",
      "\u2018your\u2019": "tila\u0301p",
      Proximate: "ti\u0301laan",
      Obviative: "p\u0268\u0301ntilaan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ti\u0301lapa",
      Obviative: "p\u0268\u0301ntilapa",
    },
  },
  {
    Group: "Grandparents",
    Relationship: "Maternal Grandmother",
    "\u2018my\u2019": {
      Vocative: "ka\u0301\u0142a",
      Absolute: "naka\u0301\u0142as",
      Associative: "naka\u0301\u0142asayin",
      Ergative: "naka\u0301\u0142asan\u0268m",
      Genitive: "naka\u0142asanmi\u0301",
      Accusative: "naka\u0301\u0142asaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "ka\u0301\u0142",
      Associative: "ka\u0301\u0142in",
      Ergative: "ka\u0142a\u0301p",
      Genitive: "ka\u0142ami\u0301",
      Accusative: "ka\u0142a\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ka\u0301\u0142a",
      Associative: "ka\u0301\u0142ayin",
      Ergative: "ka\u0301\u0142apn\u0268m",
      Genitive: "ka\u0142ami\u0301",
      Accusative: "ka\u0301\u0142aan",
      "Accusative coreferential": "ka\u0301\u0142apa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nka\u0142a",
      Associative: "p\u0268\u0301nka\u0142ayin",
      Ergative: "p\u0268\u0301nka\u0142apn\u0268m",
      Genitive: "p\u0268nka\u0142ami\u0301",
      Accusative: "p\u0268\u0301nka\u0142aan",
      "Accusative coreferential": "p\u0268\u0301nka\u0142apa",
    },
    Vocative: {
      "\u2018my\u2019": "ka\u0301\u0142a",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "naka\u0301\u0142as",
      "\u2018your\u2019": "ka\u0301\u0142",
      Proximate: "ka\u0301\u0142a",
      Obviative: "p\u0268\u0301nka\u0142a",
    },
    Associative: {
      "\u2018my\u2019": "naka\u0301\u0142asayin",
      "\u2018your\u2019": "ka\u0301\u0142in",
      Proximate: "ka\u0301\u0142ayin",
      Obviative: "p\u0268\u0301nka\u0142ayin",
    },
    Ergative: {
      "\u2018my\u2019": "naka\u0301\u0142asan\u0268m",
      "\u2018your\u2019": "ka\u0142a\u0301p",
      Proximate: "ka\u0301\u0142apn\u0268m",
      Obviative: "p\u0268\u0301nka\u0142apn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "naka\u0142asanmi\u0301",
      "\u2018your\u2019": "ka\u0142ami\u0301",
      Proximate: "ka\u0142ami\u0301",
      Obviative: "p\u0268nka\u0142ami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "naka\u0301\u0142asaan",
      "\u2018your\u2019": "ka\u0142a\u0301p",
      Proximate: "ka\u0301\u0142aan",
      Obviative: "p\u0268\u0301nka\u0142aan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ka\u0301\u0142apa",
      Obviative: "p\u0268\u0301nka\u0142apa",
    },
  },
  {
    Group: "Grandchildren",
    Relationship: "Man\u2019s Son\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "pu\u0301s\u030ca",
      Absolute: "i\u0301npus\u030ca",
      Associative: "i\u0301npus\u030cayin",
      Ergative: "i\u0301npus\u030can\u0268m",
      Genitive: "inpus\u030canmi\u0301",
      Accusative: "i\u0301npus\u030caan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpus\u030ca",
      Associative: "i\u0301mpus\u030cayin",
      Ergative: "i\u0301mpus\u030can\u0268m",
      Genitive: "impus\u030canmi\u0301",
      Accusative: "i\u0301mpus\u030caan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pu\u0301s\u030ca",
      Associative: "pu\u0301s\u030cayin",
      Ergative: "pu\u0301s\u030capn\u0268m",
      Genitive: "pus\u030cami\u0301",
      Accusative: "pu\u0301s\u030caan",
      "Accusative coreferential": "pu\u0301s\u030capa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npus\u030ca",
      Associative: "p\u0268\u0301npus\u030cayin",
      Ergative: "p\u0268\u0301npus\u030capn\u0268m",
      Genitive: "p\u0268npus\u030cami\u0301",
      Accusative: "p\u0268\u0301npus\u030caan",
      "Accusative coreferential": "p\u0268\u0301npus\u030capa",
    },
    Vocative: {
      "\u2018my\u2019": "pu\u0301s\u030ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npus\u030ca",
      "\u2018your\u2019": "i\u0301mpus\u030ca",
      Proximate: "pu\u0301s\u030ca",
      Obviative: "p\u0268\u0301npus\u030ca",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npus\u030cayin",
      "\u2018your\u2019": "i\u0301mpus\u030cayin",
      Proximate: "pu\u0301s\u030cayin",
      Obviative: "p\u0268\u0301npus\u030cayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npus\u030can\u0268m",
      "\u2018your\u2019": "i\u0301mpus\u030can\u0268m",
      Proximate: "pu\u0301s\u030capn\u0268m",
      Obviative: "p\u0268\u0301npus\u030capn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpus\u030canmi\u0301",
      "\u2018your\u2019": "impus\u030canmi\u0301",
      Proximate: "pus\u030cami\u0301",
      Obviative: "p\u0268npus\u030cami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npus\u030caan",
      "\u2018your\u2019": "i\u0301mpus\u030caan",
      Proximate: "pu\u0301s\u030caan",
      Obviative: "p\u0268\u0301npus\u030caan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pu\u0301s\u030capa",
      Obviative: "p\u0268\u0301npus\u030capa",
    },
  },
  {
    Group: "Grandchildren",
    Relationship: "Woman\u2019s Son\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "a\u0301la",
      Absolute: "i\u0301n\u02c0ala",
      Associative: "i\u0301n\u02c0alayin",
      Ergative: "i\u0301n\u02c0alan\u0268m",
      Genitive: "in\u02c0alanmi\u0301",
      Accusative: "i\u0301n\u02c0alaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301m\u02c0ala",
      Associative: "i\u0301m\u02c0alayin",
      Ergative: "i\u0301m\u02c0alan\u0268m",
      Genitive: "im\u02c0alanmi\u0301",
      Accusative: "i\u0301m\u02c0alaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301la",
      Associative: "a\u0301layin",
      Ergative: "a\u0301lapn\u0268m",
      Genitive: "alami\u0301",
      Accusative: "a\u0301laan",
      "Accusative coreferential": "a\u0301lapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0ala",
      Associative: "p\u0268\u0301n\u02c0alayin",
      Ergative: "p\u0268\u0301n\u02c0alapn\u0268m",
      Genitive: "p\u0268n\u02c0alami\u0301",
      Accusative: "p\u0268\u0301n\u02c0alaan",
      "Accusative coreferential": "p\u0268\u0301n\u02c0alapa",
    },
    Vocative: {
      "\u2018my\u2019": "a\u0301la",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301n\u02c0ala",
      "\u2018your\u2019": "i\u0301m\u02c0ala",
      Proximate: "a\u0301la",
      Obviative: "p\u0268\u0301n\u02c0ala",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301n\u02c0alayin",
      "\u2018your\u2019": "i\u0301m\u02c0alayin",
      Proximate: "a\u0301layin",
      Obviative: "p\u0268\u0301n\u02c0alayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301n\u02c0alan\u0268m",
      "\u2018your\u2019": "i\u0301m\u02c0alan\u0268m",
      Proximate: "a\u0301lapn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0alapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "in\u02c0alanmi\u0301",
      "\u2018your\u2019": "im\u02c0alanmi\u0301",
      Proximate: "alami\u0301",
      Obviative: "p\u0268n\u02c0alami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301n\u02c0alaan",
      "\u2018your\u2019": "i\u0301m\u02c0alaan",
      Proximate: "a\u0301laan",
      Obviative: "p\u0268\u0301n\u02c0alaan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301lapa",
      Obviative: "p\u0268\u0301n\u02c0alapa",
    },
  },
  {
    Group: "Grandchildren",
    Relationship: "Man\u2019s Daughter\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "ti\u0301la",
      Absolute: "i\u0301ntila",
      Associative: "i\u0301ntilayin",
      Ergative: "i\u0301ntilan\u0268m",
      Genitive: "intilanmi\u0301",
      Accusative: "i\u0301ntilaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mtila",
      Associative: "i\u0301mtilayin",
      Ergative: "i\u0301mtilan\u0268m",
      Genitive: "imtilanmi\u0301",
      Accusative: "i\u0301mtilaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ti\u0301la",
      Associative: "ti\u0301layin",
      Ergative: "ti\u0301lapn\u0268m",
      Genitive: "tilami\u0301",
      Accusative: "ti\u0301laan",
      "Accusative coreferential": "ti\u0301lapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301ntila",
      Associative: "p\u0268\u0301ntilayin",
      Ergative: "p\u0268\u0301ntilapn\u0268m",
      Genitive: "p\u0268ntilami\u0301",
      Accusative: "p\u0268\u0301ntilaan",
      "Accusative coreferential": "p\u0268\u0301ntilapa",
    },
    Vocative: {
      "\u2018my\u2019": "ti\u0301la",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301ntila",
      "\u2018your\u2019": "i\u0301mtila",
      Proximate: "ti\u0301la",
      Obviative: "p\u0268\u0301ntila",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301ntilayin",
      "\u2018your\u2019": "i\u0301mtilayin",
      Proximate: "ti\u0301layin",
      Obviative: "p\u0268\u0301ntilayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301ntilan\u0268m",
      "\u2018your\u2019": "i\u0301mtilan\u0268m",
      Proximate: "ti\u0301lapn\u0268m",
      Obviative: "p\u0268\u0301ntilapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "intilanmi\u0301",
      "\u2018your\u2019": "imtilanmi\u0301",
      Proximate: "tilami\u0301",
      Obviative: "p\u0268ntilami\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301ntilaan",
      "\u2018your\u2019": "i\u0301mtilaan",
      Proximate: "ti\u0301laan",
      Obviative: "p\u0268\u0301ntilaan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ti\u0301lapa",
      Obviative: "p\u0268\u0301ntilapa",
    },
  },
  {
    Group: "Grandchildren",
    Relationship: "Woman\u2019s Daughter\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "ka\u0301\u0142a",
      Absolute: "i\u0301nka\u0142a",
      Associative: "i\u0301nka\u0142ayin",
      Ergative: "i\u0301nka\u0142an\u0268m",
      Genitive: "inka\u0142anmi\u0301",
      Accusative: "i\u0301nka\u0142aan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mka\u0142a",
      Associative: "i\u0301mka\u0142ayin",
      Ergative: "i\u0301mka\u0142an\u0268m",
      Genitive: "imka\u0142anmi\u0301",
      Accusative: "i\u0301mka\u0142aan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ka\u0301\u0142a",
      Associative: "ka\u0301\u0142ayin",
      Ergative: "ka\u0301\u0142apn\u0268m",
      Genitive: "ka\u0142apmi\u0301",
      Accusative: "ka\u0301\u0142aan",
      "Accusative coreferential": "ka\u0301\u0142apa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nka\u0142a",
      Associative: "p\u0268\u0301nka\u0142ayin",
      Ergative: "p\u0268\u0301nka\u0142apn\u0268m",
      Genitive: "p\u0268nka\u0142apmi\u0301",
      Accusative: "p\u0268\u0301nka\u0142aan",
      "Accusative coreferential": "p\u0268\u0301nka\u0142apa",
    },
    Vocative: {
      "\u2018my\u2019": "ka\u0301\u0142a",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nka\u0142a",
      "\u2018your\u2019": "i\u0301mka\u0142a",
      Proximate: "ka\u0301\u0142a",
      Obviative: "p\u0268\u0301nka\u0142a",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nka\u0142ayin",
      "\u2018your\u2019": "i\u0301mka\u0142ayin",
      Proximate: "ka\u0301\u0142ayin",
      Obviative: "p\u0268\u0301nka\u0142ayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nka\u0142an\u0268m",
      "\u2018your\u2019": "i\u0301mka\u0142an\u0268m",
      Proximate: "ka\u0301\u0142apn\u0268m",
      Obviative: "p\u0268\u0301nka\u0142apn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inka\u0142anmi\u0301",
      "\u2018your\u2019": "imka\u0142anmi\u0301",
      Proximate: "ka\u0142apmi\u0301",
      Obviative: "p\u0268nka\u0142apmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nka\u0142aan",
      "\u2018your\u2019": "i\u0301mka\u0142aan",
      Proximate: "ka\u0301\u0142aan",
      Obviative: "p\u0268\u0301nka\u0142aan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ka\u0301\u0142apa",
      Obviative: "p\u0268\u0301nka\u0142apa",
    },
  },
  {
    Group: "Uncles and Aunts",
    Relationship: "Paternal Uncle",
    "\u2018my\u2019": {
      Vocative: "m\u0268\u0301x\u0323a",
      Absolute: "nam\u0268\u0301xas",
      Associative: "nam\u0268\u0301xasayin",
      Ergative: "nam\u0268\u0301xasan\u0268m",
      Genitive: "nam\u0268xasanmi\u0301",
      Accusative: "nam\u0268\u0301xasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "\u0268m\u0268\u0301x\u0323",
      Associative: "\u0268m\u0268\u0301x\u0323in",
      Ergative: "m\u0268x\u0323a\u0301p",
      Genitive: "m\u0268x\u0323anmi\u0301",
      Accusative: "m\u0268x\u0323a\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pi\u0301mx\u0323",
      Associative: "pi\u0301mx\u0323in",
      Ergative: "pi\u0301mx\u0323n\u0268m",
      Genitive: "pimx\u0323mi\u0301",
      Accusative: "pi\u0301mx\u0323na",
      "Accusative coreferential": "pi\u0301mx\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npimx\u0323",
      Associative: "p\u0268\u0301npimx\u0323in",
      Ergative: "p\u0268\u0301npimx\u0323n\u0268m",
      Genitive: "p\u0268npimx\u0323mi\u0301",
      Accusative: "p\u0268\u0301npimx\u0323na",
      "Accusative coreferential": "p\u0268\u0301npimx\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "m\u0268\u0301x\u0323a",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "nam\u0268\u0301xas",
      "\u2018your\u2019": "\u0268m\u0268\u0301x\u0323",
      Proximate: "pi\u0301mx\u0323",
      Obviative: "p\u0268\u0301npimx\u0323",
    },
    Associative: {
      "\u2018my\u2019": "nam\u0268\u0301xasayin",
      "\u2018your\u2019": "\u0268m\u0268\u0301x\u0323in",
      Proximate: "pi\u0301mx\u0323in",
      Obviative: "p\u0268\u0301npimx\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "nam\u0268\u0301xasan\u0268m",
      "\u2018your\u2019": "m\u0268x\u0323a\u0301p",
      Proximate: "pi\u0301mx\u0323n\u0268m",
      Obviative: "p\u0268\u0301npimx\u0323n\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "nam\u0268xasanmi\u0301",
      "\u2018your\u2019": "m\u0268x\u0323anmi\u0301",
      Proximate: "pimx\u0323mi\u0301",
      Obviative: "p\u0268npimx\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "nam\u0268\u0301xasaan",
      "\u2018your\u2019": "m\u0268x\u0323a\u0301p",
      Proximate: "pi\u0301mx\u0323na",
      Obviative: "p\u0268\u0301npimx\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pi\u0301mx\u0323pa",
      Obviative: "p\u0268\u0301npimx\u0323pa",
    },
  },
  {
    Group: "Uncles and Aunts",
    Relationship: "Maternal Uncle",
    "\u2018my\u2019": {
      Vocative: "ka\u0301ka",
      Absolute: "naka\u0301kas",
      Associative: "naka\u0301kasayin",
      Ergative: "naka\u0301kasan\u0268m",
      Genitive: "nakakasanmi\u0301",
      Accusative: "naka\u0301kasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "\u0268ka\u0301k",
      Associative: "\u0268ka\u0301kin",
      Ergative: "kaka\u0301p",
      Genitive: "kakanmi\u0301",
      Accusative: "kaka\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pi\u0301tx\u0323",
      Associative: "pi\u0301tx\u0323in",
      Ergative: "pi\u0301tx\u0323pn\u0268m",
      Genitive: "pitx\u0323mi\u0301",
      Accusative: "pi\u0301tx\u0323na",
      "Accusative coreferential": "pi\u0301tx\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npitx\u0323",
      Associative: "p\u0268\u0301npitx\u0323in",
      Ergative: "p\u0268\u0301npitx\u0323pn\u0268m",
      Genitive: "p\u0268npitx\u0323mi\u0301",
      Accusative: "p\u0268\u0301npitx\u0323na",
      "Accusative coreferential": "p\u0268\u0301npitx\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "ka\u0301ka",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "naka\u0301kas",
      "\u2018your\u2019": "\u0268ka\u0301k",
      Proximate: "pi\u0301tx\u0323",
      Obviative: "p\u0268\u0301npitx\u0323",
    },
    Associative: {
      "\u2018my\u2019": "naka\u0301kasayin",
      "\u2018your\u2019": "\u0268ka\u0301kin",
      Proximate: "pi\u0301tx\u0323in",
      Obviative: "p\u0268\u0301npitx\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "naka\u0301kasan\u0268m",
      "\u2018your\u2019": "kaka\u0301p",
      Proximate: "pi\u0301tx\u0323pn\u0268m",
      Obviative: "p\u0268\u0301npitx\u0323pn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "nakakasanmi\u0301",
      "\u2018your\u2019": "kakanmi\u0301",
      Proximate: "pitx\u0323mi\u0301",
      Obviative: "p\u0268npitx\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "naka\u0301kasaan",
      "\u2018your\u2019": "kaka\u0301p",
      Proximate: "pi\u0301tx\u0323na",
      Obviative: "p\u0268\u0301npitx\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pi\u0301tx\u0323pa",
      Obviative: "p\u0268\u0301npitx\u0323pa",
    },
  },
  {
    Group: "Uncles and Aunts",
    Relationship: "Paternal Aunt",
    "\u2018my\u2019": {
      Vocative: "s\u030ci\u0301s\u030ca",
      Absolute: "nasi\u0301sas",
      Associative: "nasi\u0301sasayin",
      Ergative: "nasi\u0301sasan\u0268m",
      Genitive: "nasisasanmi\u0301",
      Accusative: "nasi\u0301sasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "\u0268s\u030ci\u0301s\u030c",
      Associative: "\u0268s\u030ci\u0301s\u030cin",
      Ergative: "s\u030cis\u030ca\u0301p",
      Genitive: "s\u030cis\u030cami\u0301",
      Accusative: "s\u030cis\u030ca\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pis\u030ci\u0301s\u030c",
      Associative: "pis\u030ci\u0301s\u030cin",
      Ergative: "pis\u030ci\u0301s\u030cn\u0268m",
      Genitive: "pis\u030cis\u030cmi\u0301",
      Accusative: "pis\u030ci\u0301s\u030cna",
      "Accusative coreferential": "pis\u030ci\u0301s\u030cpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npis\u030cis\u030c",
      Associative: "p\u0268\u0301npis\u030cis\u030cin",
      Ergative: "p\u0268\u0301npis\u030cis\u030cn\u0268m",
      Genitive: "p\u0268npis\u030cis\u030cmi\u0301",
      Accusative: "p\u0268\u0301npis\u030cis\u030cna",
      "Accusative coreferential": "p\u0268\u0301npis\u030cis\u030cpa",
    },
    Vocative: {
      "\u2018my\u2019": "s\u030ci\u0301s\u030ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "nasi\u0301sas",
      "\u2018your\u2019": "\u0268s\u030ci\u0301s\u030c",
      Proximate: "pis\u030ci\u0301s\u030c",
      Obviative: "p\u0268\u0301npis\u030cis\u030c",
    },
    Associative: {
      "\u2018my\u2019": "nasi\u0301sasayin",
      "\u2018your\u2019": "\u0268s\u030ci\u0301s\u030cin",
      Proximate: "pis\u030ci\u0301s\u030cin",
      Obviative: "p\u0268\u0301npis\u030cis\u030cin",
    },
    Ergative: {
      "\u2018my\u2019": "nasi\u0301sasan\u0268m",
      "\u2018your\u2019": "s\u030cis\u030ca\u0301p",
      Proximate: "pis\u030ci\u0301s\u030cn\u0268m",
      Obviative: "p\u0268\u0301npis\u030cis\u030cn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "nasisasanmi\u0301",
      "\u2018your\u2019": "s\u030cis\u030cami\u0301",
      Proximate: "pis\u030cis\u030cmi\u0301",
      Obviative: "p\u0268npis\u030cis\u030cmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "nasi\u0301sasaan",
      "\u2018your\u2019": "s\u030cis\u030ca\u0301p",
      Proximate: "pis\u030ci\u0301s\u030cna",
      Obviative: "p\u0268\u0301npis\u030cis\u030cna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pis\u030ci\u0301s\u030cpa",
      Obviative: "p\u0268\u0301npis\u030cis\u030cpa",
    },
  },
  {
    Group: "Uncles and Aunts",
    Relationship: "Maternal Aunt",
    "\u2018my\u2019": {
      Vocative: "x\u0323a\u0301x\u0323a",
      Absolute: "naxa\u0301xas",
      Associative: "naxa\u0301xasayin",
      Ergative: "naxa\u0301xasan\u0268m",
      Genitive: "naxaxasanmi\u0301",
      Accusative: "naxa\u0301xasaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "\u0268x\u0323a\u0301x\u0323",
      Associative: "\u0268x\u0323a\u0301x\u0323in",
      Ergative: "x\u0323ax\u0323a\u0301p",
      Genitive: "x\u0323ax\u0323ami\u0301",
      Accusative: "x\u0323ax\u0323a\u0301p",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pax\u0323a\u0301x\u0323",
      Associative: "pax\u0323a\u0301x\u0323in",
      Ergative: "pax\u0323a\u0301x\u0323n\u0268m",
      Genitive: "pax\u0323ax\u0323mi\u0301",
      Accusative: "pax\u0323a\u0301x\u0323na",
      "Accusative coreferential": "pax\u0323a\u0301x\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npax\u0323ax\u0323",
      Associative: "p\u0268\u0301npax\u0323ax\u0323in",
      Ergative: "p\u0268\u0301npax\u0323ax\u0323n\u0268m",
      Genitive: "p\u0268npax\u0323ax\u0323mi\u0301",
      Accusative: "p\u0268\u0301npax\u0323ax\u0323na",
      "Accusative coreferential": "p\u0268\u0301npax\u0323ax\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "x\u0323a\u0301x\u0323a",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "naxa\u0301xas",
      "\u2018your\u2019": "\u0268x\u0323a\u0301x\u0323",
      Proximate: "pax\u0323a\u0301x\u0323",
      Obviative: "p\u0268\u0301npax\u0323ax\u0323",
    },
    Associative: {
      "\u2018my\u2019": "naxa\u0301xasayin",
      "\u2018your\u2019": "\u0268x\u0323a\u0301x\u0323in",
      Proximate: "pax\u0323a\u0301x\u0323in",
      Obviative: "p\u0268\u0301npax\u0323ax\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "naxa\u0301xasan\u0268m",
      "\u2018your\u2019": "x\u0323ax\u0323a\u0301p",
      Proximate: "pax\u0323a\u0301x\u0323n\u0268m",
      Obviative: "p\u0268\u0301npax\u0323ax\u0323n\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "naxaxasanmi\u0301",
      "\u2018your\u2019": "x\u0323ax\u0323ami\u0301",
      Proximate: "pax\u0323ax\u0323mi\u0301",
      Obviative: "p\u0268npax\u0323ax\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "naxa\u0301xasaan",
      "\u2018your\u2019": "x\u0323ax\u0323a\u0301p",
      Proximate: "pax\u0323a\u0301x\u0323na",
      Obviative: "p\u0268\u0301npax\u0323ax\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pax\u0323a\u0301x\u0323pa",
      Obviative: "p\u0268\u0301npax\u0323ax\u0323pa",
    },
  },
  {
    Group: "Younger Siblings",
    Relationship: "Man\u2019s Younger Brother",
    "\u2018my\u2019": {
      Vocative: "l\u0268\u0301ka",
      Absolute: "i\u0301nkaks",
      Associative: "i\u0301nkaksayin",
      Ergative: "i\u0301nkaksan\u0268m",
      Genitive: "inkaksanmi\u0301",
      Accusative: "i\u0301nkaksaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "ku\u0301ks",
      Associative: "ku\u0301ksayin",
      Ergative: "ku\u0301ksan\u0268m",
      Genitive: "kuksanmi\u0301",
      Accusative: "ku\u0301ksaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "\u0268sx\u0323\u0268\u0301p",
      Associative: "\u0268sx\u0323\u0268\u0301pin",
      Ergative: "\u0268sx\u0323\u0268\u0301pn\u0268m",
      Genitive: "\u0268sx\u0323\u0268pmi\u0301",
      Accusative: "\u0268sx\u0323\u0268\u0301pna",
      "Accusative coreferential": "\u0268sx\u0323\u0268\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268p",
      Associative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pin",
      Ergative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pn\u0268m",
      Genitive: "p\u0268n\u02c0\u0268sx\u0323\u0268pmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pa",
    },
    Vocative: {
      "\u2018my\u2019": "l\u0268\u0301ka",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nkaks",
      "\u2018your\u2019": "ku\u0301ks",
      Proximate: "\u0268sx\u0323\u0268\u0301p",
      Obviative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268p",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nkaksayin",
      "\u2018your\u2019": "ku\u0301ksayin",
      Proximate: "\u0268sx\u0323\u0268\u0301pin",
      Obviative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nkaksan\u0268m",
      "\u2018your\u2019": "ku\u0301ksan\u0268m",
      Proximate: "\u0268sx\u0323\u0268\u0301pn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inkaksanmi\u0301",
      "\u2018your\u2019": "kuksanmi\u0301",
      Proximate: "\u0268sx\u0323\u0268pmi\u0301",
      Obviative: "p\u0268n\u02c0\u0268sx\u0323\u0268pmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nkaksaan",
      "\u2018your\u2019": "ku\u0301ksaan",
      Proximate: "\u0268sx\u0323\u0268\u0301pna",
      Obviative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "\u0268sx\u0323\u0268\u0301pa",
      Obviative: "p\u0268\u0301n\u02c0\u0268sx\u0323\u0268pa",
    },
  },
  {
    Group: "Younger Siblings",
    Relationship: "Woman\u2019s Younger Brother",
    "\u2018my\u2019": {
      Vocative: "l\u0268\u0301pa",
      Absolute: "i\u0301npayc",
      Associative: "i\u0301npaysayin",
      Ergative: "i\u0301npaysan\u0268m",
      Genitive: "inpaysanmi\u0301",
      Accusative: "i\u0301npaysaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpayc",
      Associative: "i\u0301mpaysayin",
      Ergative: "i\u0301mpaysan\u0268m",
      Genitive: "impaysanmi\u0301",
      Accusative: "i\u0301mpaysaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pa\u0301yc\u030ct",
      Associative: "pa\u0301yc\u030ctin",
      Ergative: "pa\u0301yc\u030ctn\u0268m",
      Genitive: "payc\u030ctmi\u0301",
      Accusative: "pa\u0301yc\u030ctna",
      "Accusative coreferential": "pa\u0301yc\u030ctpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npayc\u030ct",
      Associative: "p\u0268\u0301npayc\u030ctin",
      Ergative: "p\u0268\u0301npayc\u030ctn\u0268m",
      Genitive: "p\u0268npayc\u030ctmi\u0301",
      Accusative: "p\u0268\u0301npayc\u030ctna",
      "Accusative coreferential": "p\u0268\u0301npayc\u030ctpa",
    },
    Vocative: {
      "\u2018my\u2019": "l\u0268\u0301pa",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npayc",
      "\u2018your\u2019": "i\u0301mpayc",
      Proximate: "pa\u0301yc\u030ct",
      Obviative: "p\u0268\u0301npayc\u030ct",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npaysayin",
      "\u2018your\u2019": "i\u0301mpaysayin",
      Proximate: "pa\u0301yc\u030ctin",
      Obviative: "p\u0268\u0301npayc\u030ctin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npaysan\u0268m",
      "\u2018your\u2019": "i\u0301mpaysan\u0268m",
      Proximate: "pa\u0301yc\u030ctn\u0268m",
      Obviative: "p\u0268\u0301npayc\u030ctn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpaysanmi\u0301",
      "\u2018your\u2019": "impaysanmi\u0301",
      Proximate: "payc\u030ctmi\u0301",
      Obviative: "p\u0268npayc\u030ctmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npaysaan",
      "\u2018your\u2019": "i\u0301mpaysaan",
      Proximate: "pa\u0301yc\u030ctna",
      Obviative: "p\u0268\u0301npayc\u030ctna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pa\u0301yc\u030ctpa",
      Obviative: "p\u0268\u0301npayc\u030ctpa",
    },
  },
  {
    Group: "Younger Siblings",
    Relationship: "Man\u2019s Younger Sister",
    "\u2018my\u2019": {
      Vocative: "l\u0268\u0301ca",
      Absolute: "i\u0301ncnits",
      Associative: "i\u0301ncnitsayin",
      Ergative: "i\u0301ncnitsan\u0268m",
      Genitive: "incnitsanmi\u0301",
      Accusative: "i\u0301ncnitsaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "cni\u0301ts",
      Associative: "cni\u0301tsayin",
      Ergative: "cni\u0301tsan\u0268m",
      Genitive: "cnisanmi\u0301",
      Accusative: "cni\u0301saan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301yc",
      Associative: "a\u0301ycin",
      Ergative: "a\u0301ycn\u0268m",
      Genitive: "aycmi\u0301",
      Accusative: "a\u0301ycna",
      "Accusative coreferential": "a\u0301ycpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0ayc",
      Associative: "p\u0268\u0301n\u02c0aycin",
      Ergative: "p\u0268\u0301n\u02c0aycn\u0268m",
      Genitive: "p\u0268n\u02c0aycmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0aycna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0aycpa",
    },
    Vocative: {
      "\u2018my\u2019": "l\u0268\u0301ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301ncnits",
      "\u2018your\u2019": "cni\u0301ts",
      Proximate: "a\u0301yc",
      Obviative: "p\u0268\u0301n\u02c0ayc",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301ncnitsayin",
      "\u2018your\u2019": "cni\u0301tsayin",
      Proximate: "a\u0301ycin",
      Obviative: "p\u0268\u0301n\u02c0aycin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301ncnitsan\u0268m",
      "\u2018your\u2019": "cni\u0301tsan\u0268m",
      Proximate: "a\u0301ycn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0aycn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "incnitsanmi\u0301",
      "\u2018your\u2019": "cnisanmi\u0301",
      Proximate: "aycmi\u0301",
      Obviative: "p\u0268n\u02c0aycmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301ncnitsaan",
      "\u2018your\u2019": "cni\u0301saan",
      Proximate: "a\u0301ycna",
      Obviative: "p\u0268\u0301n\u02c0aycna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301ycpa",
      Obviative: "p\u0268\u0301n\u02c0aycpa",
    },
  },
  {
    Group: "Younger Siblings",
    Relationship: "Woman\u2019s Younger Sister",
    "\u2018my\u2019": {
      Vocative: "li\u0301ya",
      Absolute: "i\u0301nyuks",
      Associative: "i\u0301nyuksayin",
      Ergative: "i\u0301nyuksan\u0268m",
      Genitive: "inyuksanmi\u0301",
      Accusative: "i\u0301nyuksaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301myuks",
      Associative: "i\u0301myuksayin",
      Ergative: "i\u0301myuksan\u0268m",
      Genitive: "imyuksanmi\u0301",
      Accusative: "i\u0301myuksaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "\u0268si\u0301p",
      Associative: "\u0268si\u0301pin",
      Ergative: "\u0268si\u0301pn\u0268m",
      Genitive: "\u0268sipmi\u0301",
      Accusative: "\u0268si\u0301pna",
      "Accusative coreferential": "\u0268si\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0\u0268sip",
      Associative: "p\u0268\u0301n\u02c0\u0268sipin",
      Ergative: "p\u0268\u0301n\u02c0\u0268sipn\u0268m",
      Genitive: "p\u0268n\u02c0\u0268sipmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0\u0268sipna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0\u0268sipa",
    },
    Vocative: {
      "\u2018my\u2019": "li\u0301ya",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nyuks",
      "\u2018your\u2019": "i\u0301myuks",
      Proximate: "\u0268si\u0301p",
      Obviative: "p\u0268\u0301n\u02c0\u0268sip",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nyuksayin",
      "\u2018your\u2019": "i\u0301myuksayin",
      Proximate: "\u0268si\u0301pin",
      Obviative: "p\u0268\u0301n\u02c0\u0268sipin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nyuksan\u0268m",
      "\u2018your\u2019": "i\u0301myuksan\u0268m",
      Proximate: "\u0268si\u0301pn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0\u0268sipn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inyuksanmi\u0301",
      "\u2018your\u2019": "imyuksanmi\u0301",
      Proximate: "\u0268sipmi\u0301",
      Obviative: "p\u0268n\u02c0\u0268sipmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nyuksaan",
      "\u2018your\u2019": "i\u0301myuksaan",
      Proximate: "\u0268si\u0301pna",
      Obviative: "p\u0268\u0301n\u02c0\u0268sipna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "\u0268si\u0301pa",
      Obviative: "p\u0268\u0301n\u02c0\u0268sipa",
    },
  },
  {
    Group: "Siblings",
    Relationship: "Man\u2019s Brother/Male Cousin/Male Friend",
    "\u2018my\u2019": {
      Vocative: "x\u0323a\u0301y",
      Absolute: "i\u0301nx\u0323ay",
      Associative: "i\u0301nx\u0323ayin",
      Ergative: "i\u0301nx\u0323ayn\u0268m",
      Genitive: "inx\u0323aynmi\u0301",
      Accusative: "i\u0301nx\u0323ayna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mx\u0323ay",
      Associative: "i\u0301mx\u0323ayin",
      Ergative: "i\u0301mx\u0323ayn\u0268m",
      Genitive: "imx\u0323aynmi\u0301",
      Accusative: "i\u0301mx\u0323ayna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "x\u0323a\u0301y",
      Associative: "x\u0323a\u0301yin",
      Ergative: "x\u0323a\u0301yn\u0268m",
      Genitive: "x\u0323aynmi\u0301",
      Accusative: "x\u0323a\u0301yna",
      "Accusative coreferential": "x\u0323a\u0301ypa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nx\u0323ay",
      Associative: "p\u0268\u0301nx\u0323ayin",
      Ergative: "p\u0268\u0301nx\u0323ayn\u0268m",
      Genitive: "p\u0268nx\u0323aynmi\u0301",
      Accusative: "p\u0268\u0301nx\u0323ayna",
      "Accusative coreferential": "p\u0268\u0301nx\u0323aypa",
    },
    Vocative: {
      "\u2018my\u2019": "x\u0323a\u0301y",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nx\u0323ay",
      "\u2018your\u2019": "i\u0301mx\u0323ay",
      Proximate: "x\u0323a\u0301y",
      Obviative: "p\u0268\u0301nx\u0323ay",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nx\u0323ayin",
      "\u2018your\u2019": "i\u0301mx\u0323ayin",
      Proximate: "x\u0323a\u0301yin",
      Obviative: "p\u0268\u0301nx\u0323ayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nx\u0323ayn\u0268m",
      "\u2018your\u2019": "i\u0301mx\u0323ayn\u0268m",
      Proximate: "x\u0323a\u0301yn\u0268m",
      Obviative: "p\u0268\u0301nx\u0323ayn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inx\u0323aynmi\u0301",
      "\u2018your\u2019": "imx\u0323aynmi\u0301",
      Proximate: "x\u0323aynmi\u0301",
      Obviative: "p\u0268nx\u0323aynmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nx\u0323ayna",
      "\u2018your\u2019": "i\u0301mx\u0323ayna",
      Proximate: "x\u0323a\u0301yna",
      Obviative: "p\u0268\u0301nx\u0323ayna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "x\u0323a\u0301ypa",
      Obviative: "p\u0268\u0301nx\u0323aypa",
    },
  },
  {
    Group: "Siblings",
    Relationship:
      "Woman\u2019s Sister/Female Cousin/Female Friend; Husband\u2019s Brother\u2019s Wife",
    "\u2018my\u2019": {
      Vocative: "\u019b\u0313a\u0301ks",
      Absolute: "i\u0301n\u019b\u0313aks",
      Associative: "i\u0301n\u019b\u0313aksayin",
      Ergative: "i\u0301n\u019b\u0313aksan\u0268m",
      Genitive: "in\u019b\u0313aksanmi\u0301",
      Accusative: "i\u0301n\u019b\u0313aksaan",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301m\u019b\u0313aks",
      Associative: "i\u0301m\u019b\u0313aksayin",
      Ergative: "i\u0301m\u019b\u0313aksan\u0268m",
      Genitive: "im\u019b\u0313aksanmi\u0301",
      Accusative: "i\u0301m\u019b\u0313aksaan",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "\u019b\u0313a\u0301ks",
      Associative: "\u019b\u0313a\u0301ksin",
      Ergative: "\u019b\u0313a\u0301ksn\u0268m",
      Genitive: "\u019b\u0313aksmi\u0301",
      Accusative: "\u019b\u0313a\u0301ksna",
      "Accusative coreferential": "\u019b\u0313a\u0301kspa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u019b\u0313aks",
      Associative: "p\u0268\u0301n\u019b\u0313aksin",
      Ergative: "p\u0268\u0301n\u019b\u0313aksn\u0268m",
      Genitive: "p\u0268n\u019b\u0313aksmi\u0301",
      Accusative: "p\u0268\u0301n\u019b\u0313aksna",
      "Accusative coreferential": "p\u0268\u0301n\u019b\u0313akspa",
    },
    Vocative: {
      "\u2018my\u2019": "\u019b\u0313a\u0301ks",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301n\u019b\u0313aks",
      "\u2018your\u2019": "i\u0301m\u019b\u0313aks",
      Proximate: "\u019b\u0313a\u0301ks",
      Obviative: "p\u0268\u0301n\u019b\u0313aks",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301n\u019b\u0313aksayin",
      "\u2018your\u2019": "i\u0301m\u019b\u0313aksayin",
      Proximate: "\u019b\u0313a\u0301ksin",
      Obviative: "p\u0268\u0301n\u019b\u0313aksin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301n\u019b\u0313aksan\u0268m",
      "\u2018your\u2019": "i\u0301m\u019b\u0313aksan\u0268m",
      Proximate: "\u019b\u0313a\u0301ksn\u0268m",
      Obviative: "p\u0268\u0301n\u019b\u0313aksn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "in\u019b\u0313aksanmi\u0301",
      "\u2018your\u2019": "im\u019b\u0313aksanmi\u0301",
      Proximate: "\u019b\u0313aksmi\u0301",
      Obviative: "p\u0268n\u019b\u0313aksmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301n\u019b\u0313aksaan",
      "\u2018your\u2019": "i\u0301m\u019b\u0313aksaan",
      Proximate: "\u019b\u0313a\u0301ksna",
      Obviative: "p\u0268\u0301n\u019b\u0313aksna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "\u019b\u0313a\u0301kspa",
      Obviative: "p\u0268\u0301n\u019b\u0313akspa",
    },
  },
  {
    Group: "Siblings",
    Relationship: "Cross-Sex Sibling/Cousin/Friend",
    "\u2018my\u2019": {
      Vocative: "x\u0323\u0268\u0301tway",
      Absolute: "i\u0301nx\u0323tway",
      Associative: "i\u0301nx\u0323twayin",
      Ergative: "i\u0301nx\u0323twayn\u0268m",
      Genitive: "inx\u0323twaynmi\u0301",
      Accusative: "i\u0301nx\u0323twayna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mx\u0323tway",
      Associative: "i\u0301mx\u0323twayin",
      Ergative: "i\u0301mx\u0323twayn\u0268m",
      Genitive: "imx\u0323twaynmi\u0301",
      Accusative: "i\u0301mx\u0323twayna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "x\u0323\u0268\u0301tway",
      Associative: "x\u0323\u0268\u0301twayin",
      Ergative: "x\u0323\u0268\u0301twayn\u0268m",
      Genitive: "x\u0323\u0268\u0301twaynmi\u0301",
      Accusative: "x\u0323\u0268\u0301twayna",
      "Accusative coreferential": "x\u0323\u0268\u0301twaypa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nx\u0323tway",
      Associative: "p\u0268\u0301nx\u0323twayin",
      Ergative: "p\u0268\u0301nx\u0323twayn\u0268m",
      Genitive: "p\u0268nx\u0323twaynmi\u0301",
      Accusative: "p\u0268\u0301nx\u0323twayna",
      "Accusative coreferential": "p\u0268\u0301nx\u0323twaypa",
    },
    Vocative: {
      "\u2018my\u2019": "x\u0323\u0268\u0301tway",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nx\u0323tway",
      "\u2018your\u2019": "i\u0301mx\u0323tway",
      Proximate: "x\u0323\u0268\u0301tway",
      Obviative: "p\u0268\u0301nx\u0323tway",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nx\u0323twayin",
      "\u2018your\u2019": "i\u0301mx\u0323twayin",
      Proximate: "x\u0323\u0268\u0301twayin",
      Obviative: "p\u0268\u0301nx\u0323twayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nx\u0323twayn\u0268m",
      "\u2018your\u2019": "i\u0301mx\u0323twayn\u0268m",
      Proximate: "x\u0323\u0268\u0301twayn\u0268m",
      Obviative: "p\u0268\u0301nx\u0323twayn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inx\u0323twaynmi\u0301",
      "\u2018your\u2019": "imx\u0323twaynmi\u0301",
      Proximate: "x\u0323\u0268\u0301twaynmi\u0301",
      Obviative: "p\u0268nx\u0323twaynmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nx\u0323twayna",
      "\u2018your\u2019": "i\u0301mx\u0323twayna",
      Proximate: "x\u0323\u0268\u0301twayna",
      Obviative: "p\u0268\u0301nx\u0323twayna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "x\u0323\u0268\u0301twaypa",
      Obviative: "p\u0268\u0301nx\u0323twaypa",
    },
  },
  {
    Group: "Siblings",
    Relationship: "Cross-Sex Contempory/Peer",
    "\u2018my\u2019": {
      Vocative: "tax\u0323\u0268\u0301ntway",
      Absolute: "i\u0301ntax\u0323\u0268ntway",
      Associative: "i\u0301ntax\u0323\u0268ntwayin",
      Ergative: "i\u0301ntax\u0323\u0268ntwayn\u0268m",
      Genitive: "intax\u0323\u0268ntwaynmi\u0301",
      Accusative: "i\u0301ntax\u0323\u0268ntwayna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mtax\u0323\u0268ntway",
      Associative: "i\u0301mtax\u0323\u0268ntwayin",
      Ergative: "i\u0301mtax\u0323\u0268ntwayn\u0268m",
      Genitive: "imtax\u0323\u0268ntwaynmi\u0301",
      Accusative: "i\u0301mtax\u0323\u0268ntwayna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "tax\u0323\u0268\u0301ntway",
      Associative: "tax\u0323\u0268\u0301ntwayin",
      Ergative: "tax\u0323\u0268\u0301ntwayn\u0268m",
      Genitive: "tax\u0323\u0268ntwaynmi\u0301",
      Accusative: "tax\u0323\u0268\u0301ntwayna",
      "Accusative coreferential": "tax\u0323\u0268\u0301ntwaypa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301ntax\u0323\u0268ntway",
      Associative: "p\u0268\u0301ntax\u0323\u0268ntwayin",
      Ergative: "p\u0268\u0301ntax\u0323\u0268ntwayn\u0268m",
      Genitive: "p\u0268ntax\u0323\u0268ntwaynmi\u0301",
      Accusative: "p\u0268\u0301ntax\u0323\u0268ntwayna",
      "Accusative coreferential": "p\u0268\u0301ntax\u0323\u0268ntwaypa",
    },
    Vocative: {
      "\u2018my\u2019": "tax\u0323\u0268\u0301ntway",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301ntax\u0323\u0268ntway",
      "\u2018your\u2019": "i\u0301mtax\u0323\u0268ntway",
      Proximate: "tax\u0323\u0268\u0301ntway",
      Obviative: "p\u0268\u0301ntax\u0323\u0268ntway",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301ntax\u0323\u0268ntwayin",
      "\u2018your\u2019": "i\u0301mtax\u0323\u0268ntwayin",
      Proximate: "tax\u0323\u0268\u0301ntwayin",
      Obviative: "p\u0268\u0301ntax\u0323\u0268ntwayin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301ntax\u0323\u0268ntwayn\u0268m",
      "\u2018your\u2019": "i\u0301mtax\u0323\u0268ntwayn\u0268m",
      Proximate: "tax\u0323\u0268\u0301ntwayn\u0268m",
      Obviative: "p\u0268\u0301ntax\u0323\u0268ntwayn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "intax\u0323\u0268ntwaynmi\u0301",
      "\u2018your\u2019": "imtax\u0323\u0268ntwaynmi\u0301",
      Proximate: "tax\u0323\u0268ntwaynmi\u0301",
      Obviative: "p\u0268ntax\u0323\u0268ntwaynmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301ntax\u0323\u0268ntwayna",
      "\u2018your\u2019": "i\u0301mtax\u0323\u0268ntwayna",
      Proximate: "tax\u0323\u0268\u0301ntwayna",
      Obviative: "p\u0268\u0301ntax\u0323\u0268ntwayna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "tax\u0323\u0268\u0301ntwaypa",
      Obviative: "p\u0268\u0301ntax\u0323\u0268ntwaypa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Son or Daughter",
    "\u2018my\u2019": {
      Vocative: "t\u0268\u0301ta",
      Absolute: "i\u0301nmis\u030ct",
      Associative: "i\u0301nmis\u030ctin",
      Ergative: "i\u0301nmis\u030ctan\u0268m",
      Genitive: "inmis\u030ctanmi\u0301",
      Accusative: "i\u0301nmis\u030ctna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mis\u030ct",
      Associative: "i\u0301mis\u030ctin",
      Ergative: "i\u0301mis\u030ctan\u0268m",
      Genitive: "imis\u030ctanmi\u0301",
      Accusative: "i\u0301mis\u030ctna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "i\u0301s\u030ct",
      Associative: "i\u0301s\u030ctin",
      Ergative: "i\u0301s\u030ctan\u0268m",
      Genitive: "is\u030ctanmi\u0301",
      Accusative: "i\u0301s\u030ctaan",
      "Accusative coreferential": "i\u0301s\u030ctapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0is\u030ct",
      Associative: "p\u0268\u0301n\u02c0is\u030ctin",
      Ergative: "p\u0268\u0301n\u02c0is\u030ctan\u0268m",
      Genitive: "p\u0268n\u02c0is\u030ctanmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0is\u030ctaan",
      "Accusative coreferential": "p\u0268\u0301n\u02c0is\u030ctapa",
    },
    Vocative: {
      "\u2018my\u2019": "t\u0268\u0301ta",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmis\u030ct",
      "\u2018your\u2019": "i\u0301mis\u030ct",
      Proximate: "i\u0301s\u030ct",
      Obviative: "p\u0268\u0301n\u02c0is\u030ct",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmis\u030ctin",
      "\u2018your\u2019": "i\u0301mis\u030ctin",
      Proximate: "i\u0301s\u030ctin",
      Obviative: "p\u0268\u0301n\u02c0is\u030ctin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmis\u030ctan\u0268m",
      "\u2018your\u2019": "i\u0301mis\u030ctan\u0268m",
      Proximate: "i\u0301s\u030ctan\u0268m",
      Obviative: "p\u0268\u0301n\u02c0is\u030ctan\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmis\u030ctanmi\u0301",
      "\u2018your\u2019": "imis\u030ctanmi\u0301",
      Proximate: "is\u030ctanmi\u0301",
      Obviative: "p\u0268n\u02c0is\u030ctanmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmis\u030ctna",
      "\u2018your\u2019": "i\u0301mis\u030ctna",
      Proximate: "i\u0301s\u030ctaan",
      Obviative: "p\u0268\u0301n\u02c0is\u030ctaan",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "i\u0301s\u030ctapa",
      Obviative: "p\u0268\u0301n\u02c0is\u030ctapa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Man\u2019s Daughter",
    "\u2018my\u2019": {
      Vocative: "i\u0301s\u030ca",
      Absolute: "i\u0301npap",
      Associative: "i\u0301npapin",
      Ergative: "i\u0301npapn\u0268m",
      Genitive: "inpapmi\u0301",
      Accusative: "i\u0301npapna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpap",
      Associative: "i\u0301mpapin",
      Ergative: "i\u0301mpapn\u0268m",
      Genitive: "impapmi\u0301",
      Accusative: "i\u0301mpapna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pa\u0301p",
      Associative: "pa\u0301pin",
      Ergative: "pa\u0301pn\u0268m",
      Genitive: "papmi\u0301",
      Accusative: "pa\u0301pna",
      "Accusative coreferential": "pa\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npap",
      Associative: "p\u0268\u0301npapin",
      Ergative: "p\u0268\u0301npapn\u0268m",
      Genitive: "p\u0268npapmi\u0301",
      Accusative: "p\u0268\u0301npapna",
      "Accusative coreferential": "p\u0268\u0301npapa",
    },
    Vocative: {
      "\u2018my\u2019": "i\u0301s\u030ca",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npap",
      "\u2018your\u2019": "i\u0301mpap",
      Proximate: "pa\u0301p",
      Obviative: "p\u0268\u0301npap",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npapin",
      "\u2018your\u2019": "i\u0301mpapin",
      Proximate: "pa\u0301pin",
      Obviative: "p\u0268\u0301npapin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npapn\u0268m",
      "\u2018your\u2019": "i\u0301mpapn\u0268m",
      Proximate: "pa\u0301pn\u0268m",
      Obviative: "p\u0268\u0301npapn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpapmi\u0301",
      "\u2018your\u2019": "impapmi\u0301",
      Proximate: "papmi\u0301",
      Obviative: "p\u0268npapmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npapna",
      "\u2018your\u2019": "i\u0301mpapna",
      Proximate: "pa\u0301pna",
      Obviative: "p\u0268\u0301npapna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pa\u0301pa",
      Obviative: "p\u0268\u0301npapa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Man\u2019s Brother\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "pa\u0301ya",
      Absolute: "i\u0301npax\u0323yax\u0323",
      Associative: "i\u0301npax\u0323yax\u0323in",
      Ergative: "i\u0301npax\u0323yax\u0323n\u0268m",
      Genitive: "inpax\u0323yax\u0323mi\u0301",
      Accusative: "i\u0301npax\u0323yax\u0323na",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpax\u0323yax\u0323",
      Associative: "i\u0301mpax\u0323yax\u0323in",
      Ergative: "i\u0301mpax\u0323yax\u0323n\u0268m",
      Genitive: "impax\u0323yax\u0323mi\u0301",
      Accusative: "i\u0301mpax\u0323yax\u0323na",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pax\u0323ya\u0301x\u0323",
      Associative: "pax\u0323ya\u0301x\u0323in",
      Ergative: "pax\u0323ya\u0301x\u0323n\u0268m",
      Genitive: "pax\u0323yax\u0323mi\u0301",
      Accusative: "pax\u0323ya\u0301x\u0323na",
      "Accusative coreferential": "pax\u0323ya\u0301x\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npax\u0323yax\u0323",
      Associative: "p\u0268\u0301npax\u0323yax\u0323in",
      Ergative: "p\u0268\u0301npax\u0323yax\u0323n\u0268m",
      Genitive: "p\u0268npax\u0323yax\u0323mi\u0301",
      Accusative: "p\u0268\u0301npax\u0323yax\u0323na",
      "Accusative coreferential": "p\u0268\u0301npax\u0323yax\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "pa\u0301ya",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npax\u0323yax\u0323",
      "\u2018your\u2019": "i\u0301mpax\u0323yax\u0323",
      Proximate: "pax\u0323ya\u0301x\u0323",
      Obviative: "p\u0268\u0301npax\u0323yax\u0323",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npax\u0323yax\u0323in",
      "\u2018your\u2019": "i\u0301mpax\u0323yax\u0323in",
      Proximate: "pax\u0323ya\u0301x\u0323in",
      Obviative: "p\u0268\u0301npax\u0323yax\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npax\u0323yax\u0323n\u0268m",
      "\u2018your\u2019": "i\u0301mpax\u0323yax\u0323n\u0268m",
      Proximate: "pax\u0323ya\u0301x\u0323n\u0268m",
      Obviative: "p\u0268\u0301npax\u0323yax\u0323n\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpax\u0323yax\u0323mi\u0301",
      "\u2018your\u2019": "impax\u0323yax\u0323mi\u0301",
      Proximate: "pax\u0323yax\u0323mi\u0301",
      Obviative: "p\u0268npax\u0323yax\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npax\u0323yax\u0323na",
      "\u2018your\u2019": "i\u0301mpax\u0323yax\u0323na",
      Proximate: "pax\u0323ya\u0301x\u0323na",
      Obviative: "p\u0268\u0301npax\u0323yax\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pax\u0323ya\u0301x\u0323pa",
      Obviative: "p\u0268\u0301npax\u0323yax\u0323pa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Man\u2019s Sister\u2019s Child",
    "\u2018my\u2019": {
      Vocative: "pi\u0301ti",
      Absolute: "i\u0301npitx\u0323",
      Associative: "i\u0301npitx\u0323in",
      Ergative: "i\u0301npitx\u0323n\u0268m",
      Genitive: "inpitx\u0323mi\u0301",
      Accusative: "i\u0301npitx\u0323na",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpitx\u0323",
      Associative: "i\u0301mpitx\u0323in",
      Ergative: "i\u0301mpitx\u0323n\u0268m",
      Genitive: "impitx\u0323mi\u0301",
      Accusative: "i\u0301mpitx\u0323na",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pi\u0301tx\u0323",
      Associative: "pi\u0301tx\u0323in",
      Ergative: "pi\u0301tx\u0323n\u0268m",
      Genitive: "pitx\u0323mi\u0301",
      Accusative: "pi\u0301tx\u0323na",
      "Accusative coreferential": "pi\u0301tx\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npitx\u0323",
      Associative: "p\u0268\u0301npitx\u0323in",
      Ergative: "p\u0268\u0301npitx\u0323n\u0268m",
      Genitive: "p\u0268npitx\u0323mi\u0301",
      Accusative: "p\u0268\u0301npitx\u0323na",
      "Accusative coreferential": "p\u0268\u0301npitx\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "pi\u0301ti",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npitx\u0323",
      "\u2018your\u2019": "i\u0301mpitx\u0323",
      Proximate: "pi\u0301tx\u0323",
      Obviative: "p\u0268\u0301npitx\u0323",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npitx\u0323in",
      "\u2018your\u2019": "i\u0301mpitx\u0323in",
      Proximate: "pi\u0301tx\u0323in",
      Obviative: "p\u0268\u0301npitx\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npitx\u0323n\u0268m",
      "\u2018your\u2019": "i\u0301mpitx\u0323n\u0268m",
      Proximate: "pi\u0301tx\u0323n\u0268m",
      Obviative: "p\u0268\u0301npitx\u0323n\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpitx\u0323mi\u0301",
      "\u2018your\u2019": "impitx\u0323mi\u0301",
      Proximate: "pitx\u0323mi\u0301",
      Obviative: "p\u0268npitx\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npitx\u0323na",
      "\u2018your\u2019": "i\u0301mpitx\u0323na",
      Proximate: "pi\u0301tx\u0323na",
      Obviative: "p\u0268\u0301npitx\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pi\u0301tx\u0323pa",
      Obviative: "p\u0268\u0301npitx\u0323pa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Woman\u2019s Brother\u2019s Son",
    "\u2018my\u2019": {
      Vocative: "pa\u0301mta",
      Absolute: "i\u0301npamt",
      Associative: "i\u0301npamtin",
      Ergative: "i\u0301npamtn\u0268m",
      Genitive: "inpamtmi\u0301",
      Accusative: "i\u0301npamtna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpamt",
      Associative: "i\u0301mpamtin",
      Ergative: "i\u0301mpamtn\u0268m",
      Genitive: "impamtmi\u0301",
      Accusative: "i\u0301mpamtna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pa\u0301mt",
      Associative: "pa\u0301mtin",
      Ergative: "pa\u0301mtn\u0268m",
      Genitive: "pamtmi\u0301",
      Accusative: "pa\u0301mtna",
      "Accusative coreferential": "pa\u0301mtpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npamt",
      Associative: "p\u0268\u0301npamtin",
      Ergative: "p\u0268\u0301npamtn\u0268m",
      Genitive: "p\u0268npamtmi\u0301",
      Accusative: "p\u0268\u0301npamtna",
      "Accusative coreferential": "p\u0268\u0301npamtpa",
    },
    Vocative: {
      "\u2018my\u2019": "pa\u0301mta",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npamt",
      "\u2018your\u2019": "i\u0301mpamt",
      Proximate: "pa\u0301mt",
      Obviative: "p\u0268\u0301npamt",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npamtin",
      "\u2018your\u2019": "i\u0301mpamtin",
      Proximate: "pa\u0301mtin",
      Obviative: "p\u0268\u0301npamtin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npamtn\u0268m",
      "\u2018your\u2019": "i\u0301mpamtn\u0268m",
      Proximate: "pa\u0301mtn\u0268m",
      Obviative: "p\u0268\u0301npamtn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpamtmi\u0301",
      "\u2018your\u2019": "impamtmi\u0301",
      Proximate: "pamtmi\u0301",
      Obviative: "p\u0268npamtmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npamtna",
      "\u2018your\u2019": "i\u0301mpamtna",
      Proximate: "pa\u0301mtna",
      Obviative: "p\u0268\u0301npamtna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pa\u0301mtpa",
      Obviative: "p\u0268\u0301npamtpa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Woman\u2019s Brother\u2019s Daughter",
    "\u2018my\u2019": {
      Vocative: "pawa\u0301y",
      Absolute: "i\u0301npawat",
      Associative: "i\u0301npawatin",
      Ergative: "i\u0301npawatn\u0268m",
      Genitive: "inpawatmi\u0301",
      Accusative: "i\u0301npawatna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpawat",
      Associative: "i\u0301mpawatin",
      Ergative: "i\u0301mpawatn\u0268m",
      Genitive: "impawatmi\u0301",
      Accusative: "i\u0301mpawatna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pawa\u0301t",
      Associative: "pawa\u0301tin",
      Ergative: "pawa\u0301tn\u0268m",
      Genitive: "pawatmi\u0301",
      Accusative: "pawa\u0301tna",
      "Accusative coreferential": "pawa\u0301tpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npawat",
      Associative: "p\u0268\u0301npawatin",
      Ergative: "p\u0268\u0301npawatn\u0268m",
      Genitive: "p\u0268npawatmi\u0301",
      Accusative: "p\u0268\u0301npawatna",
      "Accusative coreferential": "p\u0268\u0301npawatpa",
    },
    Vocative: {
      "\u2018my\u2019": "pawa\u0301y",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npawat",
      "\u2018your\u2019": "i\u0301mpawat",
      Proximate: "pawa\u0301t",
      Obviative: "p\u0268\u0301npawat",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npawatin",
      "\u2018your\u2019": "i\u0301mpawatin",
      Proximate: "pawa\u0301tin",
      Obviative: "p\u0268\u0301npawatin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npawatn\u0268m",
      "\u2018your\u2019": "i\u0301mpawatn\u0268m",
      Proximate: "pawa\u0301tn\u0268m",
      Obviative: "p\u0268\u0301npawatn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpawatmi\u0301",
      "\u2018your\u2019": "impawatmi\u0301",
      Proximate: "pawatmi\u0301",
      Obviative: "p\u0268npawatmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npawatna",
      "\u2018your\u2019": "i\u0301mpawatna",
      Proximate: "pawa\u0301tna",
      Obviative: "p\u0268\u0301npawatna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pawa\u0301tpa",
      Obviative: "p\u0268\u0301npawatpa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Woman\u2019s Sister\u2019s Son",
    "\u2018my\u2019": {
      Vocative: "i\u0301ti",
      Absolute: "i\u0301nmitt",
      Associative: "i\u0301nmittin",
      Ergative: "i\u0301nmittn\u0268m",
      Genitive: "inmittmi\u0301",
      Accusative: "i\u0301nmittna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mitt",
      Associative: "i\u0301mittin",
      Ergative: "i\u0301mittn\u0268m",
      Genitive: "imittmi\u0301",
      Accusative: "i\u0301mittna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "i\u0301tt",
      Associative: "i\u0301ttin",
      Ergative: "i\u0301ttn\u0268m",
      Genitive: "ittmi\u0301",
      Accusative: "i\u0301ttna",
      "Accusative coreferential": "i\u0301ttpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0itt",
      Associative: "p\u0268\u0301n\u02c0ittin",
      Ergative: "p\u0268\u0301n\u02c0ittn\u0268m",
      Genitive: "p\u0268n\u02c0ittmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0ittna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0ittpa",
    },
    Vocative: {
      "\u2018my\u2019": "i\u0301ti",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmitt",
      "\u2018your\u2019": "i\u0301mitt",
      Proximate: "i\u0301tt",
      Obviative: "p\u0268\u0301n\u02c0itt",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmittin",
      "\u2018your\u2019": "i\u0301mittin",
      Proximate: "i\u0301ttin",
      Obviative: "p\u0268\u0301n\u02c0ittin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmittn\u0268m",
      "\u2018your\u2019": "i\u0301mittn\u0268m",
      Proximate: "i\u0301ttn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0ittn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmittmi\u0301",
      "\u2018your\u2019": "imittmi\u0301",
      Proximate: "ittmi\u0301",
      Obviative: "p\u0268n\u02c0ittmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmittna",
      "\u2018your\u2019": "i\u0301mittna",
      Proximate: "i\u0301ttna",
      Obviative: "p\u0268\u0301n\u02c0ittna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "i\u0301ttpa",
      Obviative: "p\u0268\u0301n\u02c0ittpa",
    },
  },
  {
    Group: "Children, Nephews, Nieces",
    Relationship: "Woman\u2019s Sister\u2019s Daughter",
    "\u2018my\u2019": {
      Vocative: "pi\u0301si",
      Absolute: "i\u0301npsits",
      Associative: "i\u0301npsisayin",
      Ergative: "i\u0301npsisn\u0268m",
      Genitive: "inpsismi\u0301",
      Accusative: "i\u0301npsisna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpsits",
      Associative: "i\u0301mpsisayin",
      Ergative: "i\u0301mpsisn\u0268m",
      Genitive: "impsismi\u0301",
      Accusative: "i\u0301mpsisna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "psi\u0301ts",
      Associative: "psi\u0301tsin",
      Ergative: "psi\u0301tsn\u0268m",
      Genitive: "psitsmi\u0301",
      Accusative: "psi\u0301tsna",
      "Accusative coreferential": "psi\u0301tspa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npsits",
      Associative: "p\u0268\u0301npsitsin",
      Ergative: "p\u0268\u0301npsitsn\u0268m",
      Genitive: "p\u0268npsitsmi\u0301",
      Accusative: "p\u0268\u0301npsitsna",
      "Accusative coreferential": "p\u0268\u0301npsitspa",
    },
    Vocative: {
      "\u2018my\u2019": "pi\u0301si",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npsits",
      "\u2018your\u2019": "i\u0301mpsits",
      Proximate: "psi\u0301ts",
      Obviative: "p\u0268\u0301npsits",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npsisayin",
      "\u2018your\u2019": "i\u0301mpsisayin",
      Proximate: "psi\u0301tsin",
      Obviative: "p\u0268\u0301npsitsin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npsisn\u0268m",
      "\u2018your\u2019": "i\u0301mpsisn\u0268m",
      Proximate: "psi\u0301tsn\u0268m",
      Obviative: "p\u0268\u0301npsitsn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpsismi\u0301",
      "\u2018your\u2019": "impsismi\u0301",
      Proximate: "psitsmi\u0301",
      Obviative: "p\u0268npsitsmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npsisna",
      "\u2018your\u2019": "i\u0301mpsisna",
      Proximate: "psi\u0301tsna",
      Obviative: "p\u0268\u0301npsitsna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "psi\u0301tspa",
      Obviative: "p\u0268\u0301npsitspa",
    },
  },
  {
    Group: "Cross-Generational In-Laws",
    Relationship: "Man\u2019s Son-In-Law; Man\u2019s Father-In-Law",
    "\u2018my\u2019": {
      Vocative: "ps\u030ca\u0301s\u030c",
      Absolute: "i\u0301nps\u030cas\u030c",
      Associative: "i\u0301nps\u030cas\u030cin",
      Ergative: "i\u0301nps\u030cas\u030cn\u0268m",
      Genitive: "inps\u030cas\u030cmi\u0301",
      Accusative: "i\u0301nps\u030cas\u030cna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mps\u030cas\u030c",
      Associative: "i\u0301mps\u030cas\u030cin",
      Ergative: "i\u0301mps\u030cas\u030cn\u0268m",
      Genitive: "imps\u030cas\u030cmi\u0301",
      Accusative: "i\u0301mps\u030cas\u030cna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "ps\u030ca\u0301s\u030c",
      Associative: "ps\u030ca\u0301s\u030cin",
      Ergative: "ps\u030ca\u0301s\u030cn\u0268m",
      Genitive: "ps\u030cas\u030cmi\u0301",
      Accusative: "ps\u030ca\u0301s\u030cna",
      "Accusative coreferential": "ps\u030ca\u0301s\u030cpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nps\u030cas\u030c",
      Associative: "p\u0268\u0301nps\u030cas\u030cin",
      Ergative: "p\u0268\u0301nps\u030cas\u030cn\u0268m",
      Genitive: "p\u0268nps\u030cas\u030cmi\u0301",
      Accusative: "p\u0268\u0301nps\u030cas\u030cna",
      "Accusative coreferential": "p\u0268\u0301nps\u030cas\u030cpa",
    },
    Vocative: {
      "\u2018my\u2019": "ps\u030ca\u0301s\u030c",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nps\u030cas\u030c",
      "\u2018your\u2019": "i\u0301mps\u030cas\u030c",
      Proximate: "ps\u030ca\u0301s\u030c",
      Obviative: "p\u0268\u0301nps\u030cas\u030c",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nps\u030cas\u030cin",
      "\u2018your\u2019": "i\u0301mps\u030cas\u030cin",
      Proximate: "ps\u030ca\u0301s\u030cin",
      Obviative: "p\u0268\u0301nps\u030cas\u030cin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nps\u030cas\u030cn\u0268m",
      "\u2018your\u2019": "i\u0301mps\u030cas\u030cn\u0268m",
      Proximate: "ps\u030ca\u0301s\u030cn\u0268m",
      Obviative: "p\u0268\u0301nps\u030cas\u030cn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inps\u030cas\u030cmi\u0301",
      "\u2018your\u2019": "imps\u030cas\u030cmi\u0301",
      Proximate: "ps\u030cas\u030cmi\u0301",
      Obviative: "p\u0268nps\u030cas\u030cmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nps\u030cas\u030cna",
      "\u2018your\u2019": "i\u0301mps\u030cas\u030cna",
      Proximate: "ps\u030ca\u0301s\u030cna",
      Obviative: "p\u0268\u0301nps\u030cas\u030cna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "ps\u030ca\u0301s\u030cpa",
      Obviative: "p\u0268\u0301nps\u030cas\u030cpa",
    },
  },
  {
    Group: "Cross-Generational In-Laws",
    Relationship: "Woman\u2019s Son-In-Law; Man\u2019s Mother-In-Law",
    "\u2018my\u2019": {
      Vocative: "s\u030cwa\u0301x\u0323",
      Absolute: "i\u0301ns\u030cwax\u0323",
      Associative: "i\u0301ns\u030cwax\u0323in",
      Ergative: "i\u0301ns\u030cwax\u0323n\u0268m",
      Genitive: "ins\u030cwax\u0323mi\u0301",
      Accusative: "i\u0301ns\u030cwax\u0323na",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301ms\u030cwax\u0323",
      Associative: "i\u0301ms\u030cwax\u0323in",
      Ergative: "i\u0301ms\u030cwax\u0323n\u0268m",
      Genitive: "ims\u030cwax\u0323mi\u0301",
      Accusative: "i\u0301ms\u030cwax\u0323na",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "s\u030cwa\u0301x\u0323",
      Associative: "s\u030cwa\u0301x\u0323in",
      Ergative: "s\u030cwa\u0301x\u0323n\u0268m",
      Genitive: "s\u030cwax\u0323mi\u0301",
      Accusative: "s\u030cwa\u0301x\u0323na",
      "Accusative coreferential": "s\u030cwa\u0301x\u0323pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301ns\u030cwax\u0323",
      Associative: "p\u0268\u0301ns\u030cwax\u0323in",
      Ergative: "p\u0268\u0301ns\u030cwax\u0323n\u0268m",
      Genitive: "p\u0268ns\u030cwax\u0323mi\u0301",
      Accusative: "p\u0268\u0301ns\u030cwax\u0323na",
      "Accusative coreferential": "p\u0268\u0301ns\u030cwax\u0323pa",
    },
    Vocative: {
      "\u2018my\u2019": "s\u030cwa\u0301x\u0323",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301ns\u030cwax\u0323",
      "\u2018your\u2019": "i\u0301ms\u030cwax\u0323",
      Proximate: "s\u030cwa\u0301x\u0323",
      Obviative: "p\u0268\u0301ns\u030cwax\u0323",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301ns\u030cwax\u0323in",
      "\u2018your\u2019": "i\u0301ms\u030cwax\u0323in",
      Proximate: "s\u030cwa\u0301x\u0323in",
      Obviative: "p\u0268\u0301ns\u030cwax\u0323in",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301ns\u030cwax\u0323n\u0268m",
      "\u2018your\u2019": "i\u0301ms\u030cwax\u0323n\u0268m",
      Proximate: "s\u030cwa\u0301x\u0323n\u0268m",
      Obviative: "p\u0268\u0301ns\u030cwax\u0323n\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "ins\u030cwax\u0323mi\u0301",
      "\u2018your\u2019": "ims\u030cwax\u0323mi\u0301",
      Proximate: "s\u030cwax\u0323mi\u0301",
      Obviative: "p\u0268ns\u030cwax\u0323mi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301ns\u030cwax\u0323na",
      "\u2018your\u2019": "i\u0301ms\u030cwax\u0323na",
      Proximate: "s\u030cwa\u0301x\u0323na",
      Obviative: "p\u0268\u0301ns\u030cwax\u0323na",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "s\u030cwa\u0301x\u0323pa",
      Obviative: "p\u0268\u0301ns\u030cwax\u0323pa",
    },
  },
  {
    Group: "Cross-Generational In-Laws",
    Relationship: "Son\u2019s Wife; Woman\u2019s Parent-In-Law",
    "\u2018my\u2019": {
      Vocative: "pna\u0301yc\u030c",
      Absolute: "i\u0301npnayc\u030c",
      Associative: "i\u0301npnayc\u030cin",
      Ergative: "i\u0301npnayc\u030cn\u0268m",
      Genitive: "inpnayc\u030cmi\u0301",
      Accusative: "i\u0301npnayc\u030cna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpnayc\u030c",
      Associative: "i\u0301mpnayc\u030cin",
      Ergative: "i\u0301mpnayc\u030cn\u0268m",
      Genitive: "impnayc\u030cmi\u0301",
      Accusative: "i\u0301mpnayc\u030cna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pna\u0301yc\u030c",
      Associative: "pna\u0301yc\u030cin",
      Ergative: "pna\u0301yc\u030cn\u0268m",
      Genitive: "pnayc\u030cmi\u0301",
      Accusative: "pna\u0301yc\u030cna",
      "Accusative coreferential": "pna\u0301yc\u030cpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npnayc\u030c",
      Associative: "p\u0268\u0301npnayc\u030cin",
      Ergative: "p\u0268\u0301npnayc\u030cn\u0268m",
      Genitive: "p\u0268npnayc\u030cmi\u0301",
      Accusative: "p\u0268\u0301npnayc\u030cna",
      "Accusative coreferential": "p\u0268\u0301npnayc\u030cpa",
    },
    Vocative: {
      "\u2018my\u2019": "pna\u0301yc\u030c",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npnayc\u030c",
      "\u2018your\u2019": "i\u0301mpnayc\u030c",
      Proximate: "pna\u0301yc\u030c",
      Obviative: "p\u0268\u0301npnayc\u030c",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npnayc\u030cin",
      "\u2018your\u2019": "i\u0301mpnayc\u030cin",
      Proximate: "pna\u0301yc\u030cin",
      Obviative: "p\u0268\u0301npnayc\u030cin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npnayc\u030cn\u0268m",
      "\u2018your\u2019": "i\u0301mpnayc\u030cn\u0268m",
      Proximate: "pna\u0301yc\u030cn\u0268m",
      Obviative: "p\u0268\u0301npnayc\u030cn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpnayc\u030cmi\u0301",
      "\u2018your\u2019": "impnayc\u030cmi\u0301",
      Proximate: "pnayc\u030cmi\u0301",
      Obviative: "p\u0268npnayc\u030cmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npnayc\u030cna",
      "\u2018your\u2019": "i\u0301mpnayc\u030cna",
      Proximate: "pna\u0301yc\u030cna",
      Obviative: "p\u0268\u0301npnayc\u030cna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pna\u0301yc\u030cpa",
      Obviative: "p\u0268\u0301npnayc\u030cpa",
    },
  },
  {
    Group: "Cross-Generational In-Laws",
    Relationship: "Child-In-Law\u2019s Parent",
    "\u2018my\u2019": {
      Vocative: "pi\u0301wnas\u030c",
      Absolute: "i\u0301npiwnas\u030c",
      Associative: "i\u0301npiwnas\u030cin",
      Ergative: "i\u0301npiwnas\u030cn\u0268m",
      Genitive: "inpiwnas\u030cmi\u0301",
      Accusative: "i\u0301npiwnas\u030cna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpiwnas\u030c",
      Associative: "i\u0301mpiwnas\u030cin",
      Ergative: "i\u0301mpiwnas\u030cn\u0268m",
      Genitive: "impiwnas\u030cmi\u0301",
      Accusative: "i\u0301mpiwnas\u030cna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pi\u0301wnas\u030c",
      Associative: "pi\u0301wnas\u030cin",
      Ergative: "pi\u0301wnas\u030cn\u0268m",
      Genitive: "piwnas\u030cmi\u0301",
      Accusative: "pi\u0301wnas\u030cna",
      "Accusative coreferential": "pi\u0301wnas\u030cpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npiwnas\u030c",
      Associative: "p\u0268\u0301npiwnas\u030cin",
      Ergative: "p\u0268\u0301npiwnas\u030cn\u0268m",
      Genitive: "p\u0268npiwnas\u030cmi\u0301",
      Accusative: "p\u0268\u0301npiwnas\u030cna",
      "Accusative coreferential": "p\u0268\u0301npiwnas\u030cpa",
    },
    Vocative: {
      "\u2018my\u2019": "pi\u0301wnas\u030c",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npiwnas\u030c",
      "\u2018your\u2019": "i\u0301mpiwnas\u030c",
      Proximate: "pi\u0301wnas\u030c",
      Obviative: "p\u0268\u0301npiwnas\u030c",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npiwnas\u030cin",
      "\u2018your\u2019": "i\u0301mpiwnas\u030cin",
      Proximate: "pi\u0301wnas\u030cin",
      Obviative: "p\u0268\u0301npiwnas\u030cin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npiwnas\u030cn\u0268m",
      "\u2018your\u2019": "i\u0301mpiwnas\u030cn\u0268m",
      Proximate: "pi\u0301wnas\u030cn\u0268m",
      Obviative: "p\u0268\u0301npiwnas\u030cn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpiwnas\u030cmi\u0301",
      "\u2018your\u2019": "impiwnas\u030cmi\u0301",
      Proximate: "piwnas\u030cmi\u0301",
      Obviative: "p\u0268npiwnas\u030cmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npiwnas\u030cna",
      "\u2018your\u2019": "i\u0301mpiwnas\u030cna",
      Proximate: "pi\u0301wnas\u030cna",
      Obviative: "p\u0268\u0301npiwnas\u030cna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pi\u0301wnas\u030cpa",
      Obviative: "p\u0268\u0301npiwnas\u030cpa",
    },
  },
  {
    Group: "Sibling In-Laws",
    Relationship: "Man\u2019s Brother-In-Law",
    "\u2018my\u2019": {
      Vocative: "miyu\u0301",
      Absolute: "i\u0301nmiyu",
      Associative: "i\u0301nmiyuwin",
      Ergative: "i\u0301nmiyun\u0268m",
      Genitive: "inmiyunmi\u0301",
      Accusative: "i\u0301nmiyuna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mmiyu",
      Associative: "i\u0301mmiyuwin",
      Ergative: "i\u0301mmiyun\u0268m",
      Genitive: "immiyunmi\u0301",
      Accusative: "i\u0301mmiyuna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "miyu\u0301",
      Associative: "miyu\u0301win",
      Ergative: "miyu\u0301n\u0268m",
      Genitive: "miyumi\u0301",
      Accusative: "miyu\u0301na",
      "Accusative coreferential": "miyu\u0301pa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nmiyu",
      Associative: "p\u0268\u0301nmiyuwin",
      Ergative: "p\u0268\u0301nmiyun\u0268m",
      Genitive: "p\u0268nmiyumi\u0301",
      Accusative: "p\u0268\u0301nmiyuna",
      "Accusative coreferential": "p\u0268\u0301nmiyupa",
    },
    Vocative: {
      "\u2018my\u2019": "miyu\u0301",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmiyu",
      "\u2018your\u2019": "i\u0301mmiyu",
      Proximate: "miyu\u0301",
      Obviative: "p\u0268\u0301nmiyu",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmiyuwin",
      "\u2018your\u2019": "i\u0301mmiyuwin",
      Proximate: "miyu\u0301win",
      Obviative: "p\u0268\u0301nmiyuwin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmiyun\u0268m",
      "\u2018your\u2019": "i\u0301mmiyun\u0268m",
      Proximate: "miyu\u0301n\u0268m",
      Obviative: "p\u0268\u0301nmiyun\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmiyunmi\u0301",
      "\u2018your\u2019": "immiyunmi\u0301",
      Proximate: "miyumi\u0301",
      Obviative: "p\u0268nmiyumi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmiyuna",
      "\u2018your\u2019": "i\u0301mmiyuna",
      Proximate: "miyu\u0301na",
      Obviative: "p\u0268\u0301nmiyuna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "miyu\u0301pa",
      Obviative: "p\u0268\u0301nmiyupa",
    },
  },
  {
    Group: "Sibling In-Laws",
    Relationship: "Woman\u2019s Sister-In-Law",
    "\u2018my\u2019": {
      Vocative: "a\u0301yc\u030c",
      Absolute: "i\u0301nmayc\u030c",
      Associative: "i\u0301nmayc\u030cin",
      Ergative: "i\u0301nmayc\u030cn\u0268m",
      Genitive: "inmayc\u030cmi\u0301",
      Accusative: "i\u0301nmayc\u030cna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mayc\u030c",
      Associative: "i\u0301mayc\u030cin",
      Ergative: "i\u0301mayc\u030cn\u0268m",
      Genitive: "imayc\u030cmi\u0301",
      Accusative: "i\u0301mayc\u030cna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301yc\u030c",
      Associative: "a\u0301yc\u030cin",
      Ergative: "a\u0301yc\u030cn\u0268m",
      Genitive: "ayc\u030cmi\u0301",
      Accusative: "a\u0301yc\u030cna",
      "Accusative coreferential": "a\u0301yc\u030cpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0ayc\u030c",
      Associative: "p\u0268\u0301n\u02c0ayc\u030cin",
      Ergative: "p\u0268\u0301n\u02c0ayc\u030cn\u0268m",
      Genitive: "p\u0268n\u02c0ayc\u030cmi\u0301",
      Accusative: "p\u0268\u0301n\u02c0ayc\u030cna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0ayc\u030cpa",
    },
    Vocative: {
      "\u2018my\u2019": "a\u0301yc\u030c",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmayc\u030c",
      "\u2018your\u2019": "i\u0301mayc\u030c",
      Proximate: "a\u0301yc\u030c",
      Obviative: "p\u0268\u0301n\u02c0ayc\u030c",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmayc\u030cin",
      "\u2018your\u2019": "i\u0301mayc\u030cin",
      Proximate: "a\u0301yc\u030cin",
      Obviative: "p\u0268\u0301n\u02c0ayc\u030cin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmayc\u030cn\u0268m",
      "\u2018your\u2019": "i\u0301mayc\u030cn\u0268m",
      Proximate: "a\u0301yc\u030cn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0ayc\u030cn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmayc\u030cmi\u0301",
      "\u2018your\u2019": "imayc\u030cmi\u0301",
      Proximate: "ayc\u030cmi\u0301",
      Obviative: "p\u0268n\u02c0ayc\u030cmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmayc\u030cna",
      "\u2018your\u2019": "i\u0301mayc\u030cna",
      Proximate: "a\u0301yc\u030cna",
      Obviative: "p\u0268\u0301n\u02c0ayc\u030cna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301yc\u030cpa",
      Obviative: "p\u0268\u0301n\u02c0ayc\u030cpa",
    },
  },
  {
    Group: "Sibling In-Laws",
    Relationship: "Cross-Sex Sibling-In-Law (While Connecting Kin Lives)",
    "\u2018my\u2019": {
      Vocative: "pnu\u0301k",
      Absolute: "i\u0301npnuk",
      Associative: "i\u0301npnukin",
      Ergative: "i\u0301npnukn\u0268m",
      Genitive: "inpnukmi\u0301",
      Accusative: "i\u0301npnukna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mpnuk",
      Associative: "i\u0301mpnukin",
      Ergative: "i\u0301mpnukn\u0268m",
      Genitive: "impnukmi\u0301",
      Accusative: "i\u0301mpnukna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "pnu\u0301k",
      Associative: "pnu\u0301kin",
      Ergative: "pnu\u0301kn\u0268m",
      Genitive: "pnukmi\u0301",
      Accusative: "pnu\u0301kna",
      "Accusative coreferential": "pnu\u0301kpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301npnuk",
      Associative: "p\u0268\u0301npnukin",
      Ergative: "p\u0268\u0301npnukn\u0268m",
      Genitive: "p\u0268npnukmi\u0301",
      Accusative: "p\u0268\u0301npnukna",
      "Accusative coreferential": "p\u0268\u0301npnukpa",
    },
    Vocative: {
      "\u2018my\u2019": "pnu\u0301k",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301npnuk",
      "\u2018your\u2019": "i\u0301mpnuk",
      Proximate: "pnu\u0301k",
      Obviative: "p\u0268\u0301npnuk",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301npnukin",
      "\u2018your\u2019": "i\u0301mpnukin",
      Proximate: "pnu\u0301kin",
      Obviative: "p\u0268\u0301npnukin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301npnukn\u0268m",
      "\u2018your\u2019": "i\u0301mpnukn\u0268m",
      Proximate: "pnu\u0301kn\u0268m",
      Obviative: "p\u0268\u0301npnukn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inpnukmi\u0301",
      "\u2018your\u2019": "impnukmi\u0301",
      Proximate: "pnukmi\u0301",
      Obviative: "p\u0268npnukmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301npnukna",
      "\u2018your\u2019": "i\u0301mpnukna",
      Proximate: "pnu\u0301kna",
      Obviative: "p\u0268\u0301npnukna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "pnu\u0301kpa",
      Obviative: "p\u0268\u0301npnukpa",
    },
  },
  {
    Group: "Sibling In-Laws",
    Relationship: "Cross-Sex Sibling-In-Law (With Death of Connecting Kin)",
    "\u2018my\u2019": {
      Vocative: "awi\u0301t",
      Absolute: "i\u0301nmawit",
      Associative: "i\u0301nmawitin",
      Ergative: "i\u0301nmawitn\u0268m",
      Genitive: "inmawitmi\u0301",
      Accusative: "i\u0301nmawitna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mawit",
      Associative: "i\u0301mawitin",
      Ergative: "i\u0301mawitn\u0268m",
      Genitive: "imawitmi\u0301",
      Accusative: "i\u0301mawitna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "awi\u0301t",
      Associative: "awi\u0301tin",
      Ergative: "awi\u0301tn\u0268m",
      Genitive: "awitmi\u0301",
      Accusative: "awi\u0301tna",
      "Accusative coreferential": "awi\u0301tpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nawit",
      Associative: "p\u0268\u0301nawitin",
      Ergative: "p\u0268\u0301nawitn\u0268m",
      Genitive: "p\u0268nawitmi\u0301",
      Accusative: "p\u0268\u0301nawitna",
      "Accusative coreferential": "p\u0268\u0301nawitpa",
    },
    Vocative: {
      "\u2018my\u2019": "awi\u0301t",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmawit",
      "\u2018your\u2019": "i\u0301mawit",
      Proximate: "awi\u0301t",
      Obviative: "p\u0268\u0301nawit",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmawitin",
      "\u2018your\u2019": "i\u0301mawitin",
      Proximate: "awi\u0301tin",
      Obviative: "p\u0268\u0301nawitin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmawitn\u0268m",
      "\u2018your\u2019": "i\u0301mawitn\u0268m",
      Proximate: "awi\u0301tn\u0268m",
      Obviative: "p\u0268\u0301nawitn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmawitmi\u0301",
      "\u2018your\u2019": "imawitmi\u0301",
      Proximate: "awitmi\u0301",
      Obviative: "p\u0268nawitmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmawitna",
      "\u2018your\u2019": "i\u0301mawitna",
      Proximate: "awi\u0301tna",
      Obviative: "p\u0268\u0301nawitna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "awi\u0301tpa",
      Obviative: "p\u0268\u0301nawitpa",
    },
  },
  {
    Group: "Miscellaneous",
    Relationship: "Husband",
    "\u2018my\u2019": {
      Vocative: "a\u0301m",
      Absolute: "i\u0301nmam",
      Associative: "i\u0301nmamin",
      Ergative: "i\u0301nmamn\u0268m",
      Genitive: "inmammi\u0301",
      Accusative: "i\u0301nmamna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mam",
      Associative: "i\u0301mamin",
      Ergative: "i\u0301mamn\u0268m",
      Genitive: "imammi\u0301",
      Accusative: "i\u0301mamna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301m",
      Associative: "a\u0301min",
      Ergative: "a\u0301mn\u0268m",
      Genitive: "ammi\u0301",
      Accusative: "a\u0301mna",
      "Accusative coreferential": "a\u0301mapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0am",
      Associative: "p\u0268\u0301n\u02c0amin",
      Ergative: "p\u0268\u0301n\u02c0amn\u0268m",
      Genitive: "p\u0268n\u02c0ammi\u0301",
      Accusative: "p\u0268\u0301n\u02c0amna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0amapa",
    },
    Vocative: {
      "\u2018my\u2019": "a\u0301m",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmam",
      "\u2018your\u2019": "i\u0301mam",
      Proximate: "a\u0301m",
      Obviative: "p\u0268\u0301n\u02c0am",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmamin",
      "\u2018your\u2019": "i\u0301mamin",
      Proximate: "a\u0301min",
      Obviative: "p\u0268\u0301n\u02c0amin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmamn\u0268m",
      "\u2018your\u2019": "i\u0301mamn\u0268m",
      Proximate: "a\u0301mn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0amn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmammi\u0301",
      "\u2018your\u2019": "imammi\u0301",
      Proximate: "ammi\u0301",
      Obviative: "p\u0268n\u02c0ammi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmamna",
      "\u2018your\u2019": "i\u0301mamna",
      Proximate: "a\u0301mna",
      Obviative: "p\u0268\u0301n\u02c0amna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301mapa",
      Obviative: "p\u0268\u0301n\u02c0amapa",
    },
  },
  {
    Group: "Miscellaneous",
    Relationship: "Wife",
    "\u2018my\u2019": {
      Vocative: "a\u0301s\u030cam",
      Absolute: "i\u0301nmas\u030cam",
      Associative: "i\u0301nmas\u030camin",
      Ergative: "i\u0301nmas\u030camn\u0268m",
      Genitive: "inmas\u030cammi\u0301",
      Accusative: "i\u0301nmas\u030camna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mas\u030cam",
      Associative: "i\u0301mas\u030camin",
      Ergative: "i\u0301mas\u030camn\u0268m",
      Genitive: "imas\u030cammi\u0301",
      Accusative: "i\u0301mas\u030camna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "a\u0301s\u030cam",
      Associative: "a\u0301s\u030camin",
      Ergative: "a\u0301s\u030camn\u0268m",
      Genitive: "as\u030cammi\u0301",
      Accusative: "a\u0301s\u030camna",
      "Accusative coreferential": "a\u0301s\u030caapa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301n\u02c0as\u030cam",
      Associative: "p\u0268\u0301n\u02c0as\u030camin",
      Ergative: "p\u0268\u0301n\u02c0as\u030camn\u0268m",
      Genitive: "p\u0268n\u02c0as\u030cammi\u0301",
      Accusative: "p\u0268\u0301n\u02c0as\u030camna",
      "Accusative coreferential": "p\u0268\u0301n\u02c0as\u030caapa",
    },
    Vocative: {
      "\u2018my\u2019": "a\u0301s\u030cam",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nmas\u030cam",
      "\u2018your\u2019": "i\u0301mas\u030cam",
      Proximate: "a\u0301s\u030cam",
      Obviative: "p\u0268\u0301n\u02c0as\u030cam",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nmas\u030camin",
      "\u2018your\u2019": "i\u0301mas\u030camin",
      Proximate: "a\u0301s\u030camin",
      Obviative: "p\u0268\u0301n\u02c0as\u030camin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nmas\u030camn\u0268m",
      "\u2018your\u2019": "i\u0301mas\u030camn\u0268m",
      Proximate: "a\u0301s\u030camn\u0268m",
      Obviative: "p\u0268\u0301n\u02c0as\u030camn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inmas\u030cammi\u0301",
      "\u2018your\u2019": "imas\u030cammi\u0301",
      Proximate: "as\u030cammi\u0301",
      Obviative: "p\u0268n\u02c0as\u030cammi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nmas\u030camna",
      "\u2018your\u2019": "i\u0301mas\u030camna",
      Proximate: "a\u0301s\u030camna",
      Obviative: "p\u0268\u0301n\u02c0as\u030camna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "a\u0301s\u030caapa",
      Obviative: "p\u0268\u0301n\u02c0as\u030caapa",
    },
  },
  {
    Group: "Miscellaneous",
    Relationship: "Trading Partner",
    "\u2018my\u2019": {
      Vocative: "yal\u0268\u0301pt",
      Absolute: "i\u0301nyal\u0268pt",
      Associative: "i\u0301nyal\u0268ptin",
      Ergative: "i\u0301nyal\u0268ptn\u0268m",
      Genitive: "inyal\u0268ptmi\u0301",
      Accusative: "i\u0301nyal\u0268ptna",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301myal\u0268pt",
      Associative: "i\u0301myal\u0268ptin",
      Ergative: "i\u0301myal\u0268ptn\u0268m",
      Genitive: "imyal\u0268ptmi\u0301",
      Accusative: "i\u0301myal\u0268ptna",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "yal\u0268\u0301pt",
      Associative: "yal\u0268\u0301ptin",
      Ergative: "yal\u0268\u0301ptn\u0268m",
      Genitive: "yal\u0268ptmi\u0301",
      Accusative: "yal\u0268\u0301ptna",
      "Accusative coreferential": "yal\u0268\u0301ptpa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nyal\u0268pt",
      Associative: "p\u0268\u0301nyal\u0268ptin",
      Ergative: "p\u0268\u0301nyal\u0268ptn\u0268m",
      Genitive: "p\u0268nyal\u0268ptmi\u0301",
      Accusative: "p\u0268\u0301nyal\u0268ptna",
      "Accusative coreferential": "p\u0268\u0301nyal\u0268ptpa",
    },
    Vocative: {
      "\u2018my\u2019": "yal\u0268\u0301pt",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nyal\u0268pt",
      "\u2018your\u2019": "i\u0301myal\u0268pt",
      Proximate: "yal\u0268\u0301pt",
      Obviative: "p\u0268\u0301nyal\u0268pt",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nyal\u0268ptin",
      "\u2018your\u2019": "i\u0301myal\u0268ptin",
      Proximate: "yal\u0268\u0301ptin",
      Obviative: "p\u0268\u0301nyal\u0268ptin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nyal\u0268ptn\u0268m",
      "\u2018your\u2019": "i\u0301myal\u0268ptn\u0268m",
      Proximate: "yal\u0268\u0301ptn\u0268m",
      Obviative: "p\u0268\u0301nyal\u0268ptn\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "inyal\u0268ptmi\u0301",
      "\u2018your\u2019": "imyal\u0268ptmi\u0301",
      Proximate: "yal\u0268ptmi\u0301",
      Obviative: "p\u0268nyal\u0268ptmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nyal\u0268ptna",
      "\u2018your\u2019": "i\u0301myal\u0268ptna",
      Proximate: "yal\u0268\u0301ptna",
      Obviative: "p\u0268\u0301nyal\u0268ptna",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "yal\u0268\u0301ptpa",
      Obviative: "p\u0268\u0301nyal\u0268ptpa",
    },
  },
  {
    Group: "Miscellaneous",
    Relationship: "Pet",
    "\u2018my\u2019": {
      Vocative: "k\u0313u\u0301\u0142i",
      Absolute: "i\u0301nk\u0313u\u0142i",
      Associative: "i\u0301nk\u0313u\u0142iyin",
      Ergative: "i\u0301nk\u0313u\u0142in\u0268m",
      Genitive: "ink\u0313u\u0142inmi\u0301",
      Accusative: "i\u0301nk\u0313u\u0142ina",
      "Accusative coreferential": "",
    },
    "\u2018your\u2019": {
      Vocative: "",
      Absolute: "i\u0301mk\u0313u\u0142i",
      Associative: "i\u0301mk\u0313u\u0142iyin",
      Ergative: "i\u0301mk\u0313u\u0142in\u0268m",
      Genitive: "imk\u0313u\u0142inmi\u0301",
      Accusative: "i\u0301mk\u0313u\u0142ina",
      "Accusative coreferential": "",
    },
    Proximate: {
      Vocative: "",
      Absolute: "i\u0301mk\u0313u\u0142i",
      Associative: "i\u0301mk\u0313u\u0142iyin",
      Ergative: "i\u0301mk\u0313u\u0142in\u0268m",
      Genitive: "k\u0313u\u0142inmi\u0301",
      Accusative: "i\u0301mk\u0313u\u0142ina",
      "Accusative coreferential": "i\u0301mk\u0313u\u0142ipa",
    },
    Obviative: {
      Vocative: "",
      Absolute: "p\u0268\u0301nk\u0313u\u0142i",
      Associative: "p\u0268\u0301nk\u0313u\u0142iyin",
      Ergative: "p\u0268\u0301nk\u0313u\u0142in\u0268m",
      Genitive: "p\u0268nk\u0313u\u0142inmi\u0301",
      Accusative: "p\u0268\u0301nk\u0313u\u0142ina",
      "Accusative coreferential": "p\u0268\u0301nk\u0313u\u0142ipa",
    },
    Vocative: {
      "\u2018my\u2019": "k\u0313u\u0301\u0142i",
      "\u2018your\u2019": "",
      Proximate: "",
      Obviative: "",
    },
    Absolute: {
      "\u2018my\u2019": "i\u0301nk\u0313u\u0142i",
      "\u2018your\u2019": "i\u0301mk\u0313u\u0142i",
      Proximate: "i\u0301mk\u0313u\u0142i",
      Obviative: "p\u0268\u0301nk\u0313u\u0142i",
    },
    Associative: {
      "\u2018my\u2019": "i\u0301nk\u0313u\u0142iyin",
      "\u2018your\u2019": "i\u0301mk\u0313u\u0142iyin",
      Proximate: "i\u0301mk\u0313u\u0142iyin",
      Obviative: "p\u0268\u0301nk\u0313u\u0142iyin",
    },
    Ergative: {
      "\u2018my\u2019": "i\u0301nk\u0313u\u0142in\u0268m",
      "\u2018your\u2019": "i\u0301mk\u0313u\u0142in\u0268m",
      Proximate: "i\u0301mk\u0313u\u0142in\u0268m",
      Obviative: "p\u0268\u0301nk\u0313u\u0142in\u0268m",
    },
    Genitive: {
      "\u2018my\u2019": "ink\u0313u\u0142inmi\u0301",
      "\u2018your\u2019": "imk\u0313u\u0142inmi\u0301",
      Proximate: "k\u0313u\u0142inmi\u0301",
      Obviative: "p\u0268nk\u0313u\u0142inmi\u0301",
    },
    Accusative: {
      "\u2018my\u2019": "i\u0301nk\u0313u\u0142ina",
      "\u2018your\u2019": "i\u0301mk\u0313u\u0142ina",
      Proximate: "i\u0301mk\u0313u\u0142ina",
      Obviative: "p\u0268\u0301nk\u0313u\u0142ina",
    },
    "Accusative coreferential": {
      "\u2018my\u2019": "",
      "\u2018your\u2019": "",
      Proximate: "i\u0301mk\u0313u\u0142ipa",
      Obviative: "p\u0268\u0301nk\u0313u\u0142ipa",
    },
  },
];

const main = document.querySelector("main") ?? document.createElement("main");
if (!main.parentElement) {
  document.body.append(main);
}

const groups = {};
terms.map((term) => {
  if (!groups[term.Group]) {
    groups[term.Group] = {
      label: term.Group,
      terms: [],
    };
  }
  groups[term.Group].terms.push(term);
});

Object.values(groups).map((group) => {
  const section = mnml.createHTML(`<section><h2>${group.label}</h2></section>`);
  group.terms.map((term) => {
    const table = mnml.createHTML(
      `<table>
        <caption>${term.Relationship}</caption>
        <col />
        <col />
        <col />
        <col />
        <col />
        <thead>
            <tr>
                <th scope="col">&nbsp</th>
                <th scope="col">‘my’</th>
                <th scope="col">‘your’</th>
                <th scope="col">Proximate</th>
                <th scope="col">Obviative</th>
            </tr>
        </thead>
        <tbody>
        </tbody>
    </table>`
    );
    const tbody = table.querySelector("tbody");
    [
      "Vocative",
      "Absolute",
      "Associative",
      "Ergative",
      "Genitive",
      "Accusative",
      "Accusative coreferential",
    ].map((grammarCase) => {
      const cells = Object.values(term[grammarCase])
        .map((cell) => `<td>${cell}</td>`)
        .join("");

      const row = mnml.createHTML(`
            <tr>
                <th scope="col">${grammarCase}</th>
                ${cells}
            </tr>
        `);

      tbody.append(row);
    });
    section.append(table);
  });
  main.append(section);
});

mnml.listen("mouseover", "table :is(th, td)", (ev, cell) => {
  [...document.querySelectorAll("col.hover")].map((col) =>
    col.classList.remove("hover")
  );
  const table = mnml.findParent(cell, "table");
  const row = mnml.findParent(cell, "tr");
  const index = [...row.children].indexOf(cell);
  table.querySelector(`col:nth-child(${index + 1})`).classList.add("hover");
});

mnml.listen("mouseout", "table", (ev, table) => {
  [...table.querySelectorAll("col.hover")].map((col) => col.classList.remove("hover"));
});
